import React, { useState, useEffect /*, useRef*/, useContext } from "react";
import { Formik } from "formik";


import TextArea from "../framework/TextArea";
import CollapseBar from "../framework/CollapseBar";
import InputTxt from "../framework/InputTxt";
import RadioButtons from "../framework/RadioButtons";
import PhoneInput from "../framework/PhoneInput";
import Dropdown from "../framework/DropdownObj";
import CheckBoxes from "../framework/CheckBoxesObj";
import Button from "../framework/Button";
import Ribbon from "../framework/Ribbon";
import AutoComplete from "../framework/AutoComplete";

import webRootContext from "../components/webrootcontext/WebRootContext";
import { useHistory } from "react-router-dom";
import { AppConfiguration } from "../framework/AppConfigProvider";
import { OBSERVERSHIP_APPLICATION } from '../components/ObservershipApplication';
import ExpectationsPdf from "../assets/documents/ExpectationsForObservers.pdf";
import FileUpload from "../framework/FileUpload";
import { UserProfile } from "../components/UserProfileProvider";   /* Need to override UserProfile */
import { COUNTRIES_LIST } from '../components/Countries';
import { MONTHS } from '../components/Constants';
import { generateYearOptions } from '../components/utils';


function ObservershipApplicationForm(props) {
	const [saveSuccess, setSaveSuccess] = useState();
	const [saveFailed, setSaveFailed] = useState();
	const [formikError, setFormikError] = useState();
	const [formSubmitted, setFormSubmitted] = useState();
	const [responseError, setResponseError] = useState();
	const localConfig = useContext(AppConfiguration);
	const [otherInput, setOtherInput] = useState(false);
	const [bchStaff, setBchStaff] = useState(false);
	const [otherDept, setOtherDept] = useState(false);
	const [applicationCompleted, setApplicationCompleted] = useState(false);
	const [applicationId, setApplicationId] = useState();
	const [otherCitizenshipCountrySelected, setOtherCitizenshipCountrySelected] = useState(false);
	const [otherPositionCountrySelected, setOtherPositionCountrySelected] = useState(false);
	const getApplicantIdUrl = webRootContext + "/rest/dashboard/getApplicantId";

	//values to manage required fields if values entered for degree two/three 
	const [degreeTwoReq, setDegreeTwoReq] = useState(false);
	const [institutionTwoReq, setInstitutionTwoReq] = useState(false);
	const [startDateDegreeTwoReq, setStartDateDegreeTwoReq] = useState(false);
	const [endDateDegreeTwoReq, setEndDateDegreeTwoReq] = useState(false);
	const [degreeThreeReq, setDegreeThreeReq] = useState(false);
	const [institutionThreeReq, setInstitutionThreeReq] = useState(false);
	const [startDateDegreeThreeReq, setStartDateDegreeThreeReq] = useState(false);
	const [endDateDegreeThreeReq, setEndDateDegreeThreeReq] = useState(false);
	const [saving, setSaving] = useState(false);


	let [dpvalue, setDpvalue] = useState([]);

	const currentContext = useContext(UserProfile);

	const [observershipAppObject, setObservershipAppObject] = useState(OBSERVERSHIP_APPLICATION);

	const history = useHistory();

	let homeUrl = webRootContext;
	let dashboardUrl = homeUrl + "/ApplicantDashboard";

	// required documents - file upload 
	const [curriculumVitaeUploaded, setCurriculumVitaeUploaded] = useState(false);
	const [statementOfPurposeUploaded, setStatementOfPurposeUploaded] = useState(false);
	const [letterOfSupportUploaded, setLetterOfSupportUploaded] = useState(false);
	const [recentPhotographUploaded, setRecentPhotographUploaded] = useState(false);

	// dependency required for State/zip based on user country	
	const [isUS, setIsUS] = useState(false);
	if (!isUS && currentContext.userProfile !== undefined && (currentContext.userProfile.country.toLowerCase() === 'united states (us)' || currentContext.userProfile.country.toLowerCase() === 'united states')) {
		setIsUS(true);
	}


	const fileUploadInstructionMessage = 'Drag & Drop your file or <span class="filepond--label-action">Browse</span>';
	const fileUploadApi = webRootContext + "/rest/fileUploadService/fileUpload/";
	//const dateOptions = { year: "numeric", month: "2-digit", day: "2-digit", };

	const cvErrorMessage = "Curriculum vitae is required";
	const sopErrorMessage = "Statement of purpose is required";
	const losErrorMessage = "Letter of support is required";
	const rpErrorMessage = "Recent photograph is required";

	const invalidPhotoErrorMessage = "Upload a .gif, .jpeg, .jpg, .pdf, or .png file (limit 1 file under 3 MB)";
	const invalidFileErrorMessage = "Upload a .pdf (limit 1 file under 2 MB)";
	const invalidFileLength = "The file name must be under 60 characters. Delete the file and upload a new one.";

	const dataGridWithWidth = { "minWidth": "60%" };

	//Years dropdown list
	//years for postion -20 
	const yearsforPosition = generateYearOptions(21, false);
	//years for degree -40
	const yearsforDegree = generateYearOptions(41, false);
	//years for prefereed/available +2
	const yearsforPreAvi = generateYearOptions(3, true);

	const checkKeyDown = (e) => {
		if (e.key === 'Enter') e.preventDefault();
	}

	useEffect(() => {
		props.updateTitle({ "long": localConfig.configProperties.applicationName, "short": localConfig.configProperties.applicationNameAbbrev });
	}, [props, localConfig]); // eslint-disable-line


	function returnToDashboard() {
		history.push(dashboardUrl);
	}

	function validateDurationsCompare(maxDuration, minDuration) {
		let validDurations = false;

		if (!maxDuration || !minDuration) {
			validDurations = true;
		} else {
			let max = parseInt(maxDuration.match(/\d+/));
			let min = parseInt(minDuration.match(/\d+/));
			validDurations = max >= min;

		}

		return validDurations;
	}


	function isEmptyString(txt) {
		return txt === null || txt.trim() === ""
	}
	//for yearmonthpicker validation
	function isEmptyDate(date) {
		return date === "undefined/NaN" || date === "undefined" || date === "Nan" || date === "";
	}



	const successMsgContent = <div>
		<div className="padding-bottom-30">Thank you for submitting an application to the Observership Program at Boston Children’s Hospital. We will provide a status update once your application has been reviewed. Please note, the review process generally takes six weeks.</div>
		<div className="padding-bottom-30">If you have any questions, please contact the Observership Program office: <a href="mailto:observership.program@childrens.harvard.edu">observership.program@childrens.harvard.edu.</a></div>
		<div className="padding-bottom-30">Please add the Observership Program email address (observership.program@childrens.harvard.edu) to your safe sender list to make sure you receive program communications.</div>
		<div>
			<Button text={"RETURN TO DASHBOARD"} styleName={"button button--primary"} id={"returnForm"} onClick={returnToDashboard} />
		</div>
	</div>;


	const alreadySubmittedContent =
		<div>
			<div className="padding-bottom-30">This task has already been submitted.</div>
			<Button
				text={"RETURN TO DASHBOARD"}
				styleName={"button button--primary"}
				id={"button_submit"}
				type="submit"
				onClick={(e) => { returnToDashboard(); }}
			/>
		</div>;
	//Saves the application 
	function saveApplication(values, appObjectToSave) {

		let url = webRootContext + "/rest/application/saveApplication";

		let resetForm = false;
		//console.log("appObjectToSave:",appObjectToSave)

		fetch(url, {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(appObjectToSave),
			mode: "cors"
		})
			.then((response) => {

				setSaving(false);

				if (response.ok) {
					resetForm = false;
					setObservershipAppObject(OBSERVERSHIP_APPLICATION);
					setSaveSuccess(true);
					setSaveFailed(false);
				}
				else {
					resetForm = false;
					setResponseError(response.headers.get('error'));
					setSaveSuccess(false);
					setSaveFailed(true);
				}

				return response.json();
			})
			.then(
				(result) => {
					if (resetForm) {
						setObservershipAppObject(OBSERVERSHIP_APPLICATION);
					} else {
						setObservershipAppObject(observershipAppObject);
					}
				})
			.catch((err) => {
				console.log("error", err);
			}
			);

	}

	// get department list from database 
	//inside useEffect so it doesn't keep looping continuously over the result set 
	useEffect(() => {
		getDeptList();
	}, []);

	//check the application status associated with the user
	useEffect(() => {
		fetch(getApplicantIdUrl, {
			method: 'GET',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			mode: "cors"
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				setApplicationId(data.applicantId);
				setApplicationCompleted(data.isApplicationCompleted);

			}, (error) => {
				console.log("dashboard error: ", error);
			});
	}, [getApplicantIdUrl]);

	//set up static data for radio buttons and dropdowns (data not coming from a service/DB call)
	let rbSex = [
		{ id: 1, value: "F", label: "Female", selected: false, activeInd: true },
		{ id: 2, value: "M", label: "Male", selected: false, activeInd: true },
		{ id: 3, value: "U", label: "Other/Prefer not to answer", selected: false, activeInd: true },
		{ id: 4, value: "X", label: "X", selected: false, activeInd: true }
	];


	let rbEnglishProficiencyLevel = [
		{
			id: 1,
			value: "Basic/Limited",
			label: "Basic/Limited",
			selected: false,
			activeInd: true,
		},
		{
			id: 2,
			value: "Professional/Full fluency",
			label: "Professional/Full fluency",
			selected: false,
			activeInd: true,
		},
		{
			id: 3,
			value: "Native/Bilingual proficiency",
			label: "Native/Bilingual proficiency",
			selected: false,
			activeInd: true,
		}
	];

	//values here are set to Yes/No so data will match up with what admin side is expecting
	let rbUsmleYesNo = [
		{ id: 1, value: "Yes", label: "Yes", selected: false, activeInd: true },
		{ id: 2, value: "No", label: "No", selected: false, activeInd: true },
	];


	/*for radio buttons with static data,  we need to use useState to set the initial value, otherwise the radio button
   component  will not display correctly with selected option.*/
	const [sex_radios] = useState(rbSex);
	const [englishProficiencyLevel] = useState(rbEnglishProficiencyLevel);
	const [usmleYesNo] = useState(rbUsmleYesNo);

	let termsCheckbox = [
		{ id: 1, value: "true", label: "I agree to the terms & conditions", selected: false, activeInd: true },
	];

	let durationValue = [
		{
			id: 1,
			value: "1 week",
			label: "1 week",
			selected: false,
			activeInd: false
		},
		{
			id: 2,
			value: "2 weeks",
			label: "2 weeks",
			selected: false,
			activeInd: false
		},
		{
			id: 3,
			value: "3 weeks",
			label: "3 weeks",
			selected: false,
			activeInd: false
		},
		{
			id: 4,
			value: "4 weeks",
			label: "4 weeks",
			selected: false,
			activeInd: false
		},
		{
			id: 5,
			value: "5 weeks",
			label: "5 weeks",
			selected: false,
			activeInd: false
		},
		{
			id: 6,
			value: "6 weeks",
			label: "6 weeks",
			selected: false,
			activeInd: false
		},
		{
			id: 7,
			value: "7 weeks",
			label: "7 weeks",
			selected: false,
			activeInd: false
		},
		{
			id: 8,
			value: "8 weeks",
			label: "8 weeks",
			selected: false,
			activeInd: false
		},
		{
			id: 9,
			value: "9 weeks",
			label: "9 weeks",
			selected: false,
			activeInd: false
		},
		{
			id: 10,
			value: "10 weeks",
			label: "10 weeks",
			selected: false,
			activeInd: false
		},
		{
			id: 11,
			value: "11 weeks",
			label: "11 weeks",
			selected: false,
			activeInd: false
		},
		{
			id: 12,
			value: "12 weeks",
			label: "12 weeks",
			selected: false,
			activeInd: false
		}
	];

	let hearAboutData = [
		{
			id: 1,
			value: "Web Search",
			label: "Web Search",
			selected: false,
			activeInd: false
		},
		{
			id: 2,
			value: "Social Network",
			label: "Social Network",
			selected: false,
			activeInd: false
		},
		{
			id: 3,
			value: "Previous Observer",
			label: "Previous Observer",
			selected: false,
			activeInd: false
		},
		{
			id: 4,
			value: "Boston Children's Hospital Website",
			label: "Boston Children's Hospital Website",
			selected: false,
			activeInd: false
		},
		{
			id: 5,
			value: "Boston Children's Hospital Staff",
			label: "Boston Children's Hospital Staff",
			selected: false,
			activeInd: false
		},
		{
			id: 6,
			value: "Other (please specify)",
			label: "Other (please specify)",
			selected: false,
			activeInd: false
		}
	];




	// department list
	function getDeptList() {

		let url = webRootContext + "/rest/department/getDepts";

		fetch(url,
			{ mode: "no-cors" })
			.then(res => res.json())
			.then((result) => {

				let newArray = result;
				newArray.sort((a, b) => (a.departmentDataName > b.departmentDataName) ? 1 : -1)

				//Create option for "other" in dropdown and add to dataset before populating component
				let otherOption = { "departmentDataId": 1000, "departmentDataName": "Other", "id": 1000 };
				newArray.push(otherOption);


				//NOTE: values need to match keys returned by service in fetch, so if data isn't populating, check that 
				setDpvalue(newArray.map(({ id, departmentDataId, departmentDataName, label }) => ({ id: id, departmentId: departmentDataId, departmentName: departmentDataName, label: departmentDataName })));
			});
	}

	if (saving) return (<div className="div_1_col padding-top-30 normal_txt">Saving Application</div>)


	return (
		<>
			<div>
				<Formik
					enablereinitialize={true}

					initialValues={{
						"address": observershipAppObject.address,
						"addressTwo": observershipAppObject.addressTwo,
						"applicantCity": observershipAppObject.applicantCity,
						"applicantState": observershipAppObject.applicantState,
						"applicantZipCode": observershipAppObject.applicantZipCode,
						"applicantPhone": observershipAppObject.applicantPhone,
						"citizenshipCountry": observershipAppObject.citizenshipCountry,
						"legalSex": observershipAppObject.legalSex,
						"englishProficiency": observershipAppObject.englishProficiency,
						"usmleExams": observershipAppObject.usmleExams,
						"degreeOne": observershipAppObject.applicantEducation.degreeOne,
						"institutionOne": observershipAppObject.applicantEducation.institutionOne,
						"startMonthDegreeOne": observershipAppObject.applicantEducation.startMonthDegreeOne,
						"startYearDegreeOne": observershipAppObject.applicantEducation.startYearDegreeOne,
						"startDateDegreeOne": observershipAppObject.applicantEducation.startDateDegreeOne,
						"endMonthDegreeOne": observershipAppObject.applicantEducation.endMonthDegreeOne,
						"endYearDegreeOne": observershipAppObject.applicantEducation.endYearDegreeOne,
						"endDateDegreeOne": observershipAppObject.applicantEducation.endDateDegreeOne,
						"educationDatesDegreeOne": observershipAppObject.applicantEducation.educationDatesDegreeOne,
						"degreeTwo": observershipAppObject.applicantEducation.degreeTwo,
						"institutionTwo": observershipAppObject.applicantEducation.institutionTwo,
						"startMonthDegreeTwo": observershipAppObject.applicantEducation.startMonthDegreeTwo,
						"startYearDegreeTwo": observershipAppObject.applicantEducation.startYearDegreeTwo,
						"startDateDegreeTwo": observershipAppObject.applicantEducation.startDateDegreeTwo,
						"endMonthDegreeTwo": observershipAppObject.applicantEducation.endMonthDegreeTwo,
						"endYearDegreeTwo": observershipAppObject.applicantEducation.endYearDegreeTwo,
						"endDateDegreeTwo": observershipAppObject.applicantEducation.endDateDegreeTwo,
						"educationDatesDegreeTwo": observershipAppObject.applicantEducation.educationDatesDegreeTwo,
						"degreeThree": observershipAppObject.applicantEducation.degreeThree,
						"institutionThree": observershipAppObject.applicantEducation.institutionThree,
						"startMonthDegreeThree": observershipAppObject.applicantEducation.startMonthDegreeThree,
						"startYearDegreeThree": observershipAppObject.applicantEducation.startYearDegreeThree,
						"startDateDegreeThree": observershipAppObject.applicantEducation.startDateDegreeThree,
						"endMonthDegreeThree": observershipAppObject.applicantEducation.endMonthDegreeThree,
						"endYearDegreeThree": observershipAppObject.applicantEducation.endYearDegreeThree,
						"endDateDegreeThree": observershipAppObject.applicantEducation.endDateDegreeThree,
						"educationDatesDegreeThree": observershipAppObject.applicantEducation.educationDatesDegreeThree,
						"currentTitle": observershipAppObject.currentTitle,
						"department": observershipAppObject.department,
						"currentInstitution": observershipAppObject.currentInstitution,
						"positionCountry": observershipAppObject.positionCountry,
						"positionStartMonth": observershipAppObject.positionStartMonth,
						"positionStartYear": observershipAppObject.positionStartYear,
						"startDate": observershipAppObject.startDate,  //cur postion start date
						"preferredDepartment": observershipAppObject.preferredDepartment,
						"preferredDepartmentOther": "",
						"minDesiredDuration": observershipAppObject.minDesiredDuration,
						"maxDesiredDuration": observershipAppObject.maxDesiredDuration,
						"preferredStartMonth": observershipAppObject.preferredStartMonth,
						"preferredStartYear": observershipAppObject.preferredStartYear,
						"preferredStart": observershipAppObject.preferredStart,
						"preferredEndMonth": observershipAppObject.preferredEndMonth,
						"preferredEndYear": observershipAppObject.preferredEndYear,
						"preferredEnd": observershipAppObject.preferredEnd,
						"preferredMonths": observershipAppObject.preferredMonths,
						"availableStartMonth": observershipAppObject.availableStartMonth,
						"availableStartYear": observershipAppObject.availableStartYear,
						"availableStart": observershipAppObject.availableStart,
						"availableEndMonth": observershipAppObject.availableEndMonth,
						"availableEndYear": observershipAppObject.availableEndYear,
						"availableEnd": observershipAppObject.availableEnd,
						"availableMonths": observershipAppObject.availableMonths,
						"additionalComments": observershipAppObject.additionalComments,
						"termsAndConditions": observershipAppObject.termsAndConditions,
						"hearAbout": observershipAppObject.hearAbout,
						"hearAboutText": "",
						"cvUploaded": curriculumVitaeUploaded,
						"sopUploaded": statementOfPurposeUploaded,
						"losUploaded": letterOfSupportUploaded,
						"rPhotographUploaded": recentPhotographUploaded
					}}


					validate={values => {
						const errors = {};
						setFormikError(false);
						//console.log("values obj", values)
						if (observershipAppObject) {
							//main form 
							if (observershipAppObject.address) {
								values.address = observershipAppObject.address.trim();
							}

							if (observershipAppObject.addressTwo) {
								values.addressTwo = observershipAppObject.addressTwo.trim();
							}

							if (observershipAppObject.applicantCity) {
								values.applicantCity = observershipAppObject.applicantCity.trim();
							}

							if (observershipAppObject.applicantState) {
								values.applicantState = observershipAppObject.applicantState.trim();
							}

							if (observershipAppObject.applicantZipCode) {
								values.applicantZipCode = observershipAppObject.applicantZipCode.trim();
							}

							if (observershipAppObject.applicantPhone) {
								values.applicantPhone = observershipAppObject.applicantPhone.trim();
							}

							if (observershipAppObject.citizenshipCountry) {
								values.citizenshipCountry = observershipAppObject.citizenshipCountry.trim();
							}

							if (observershipAppObject.legalSex) {
								values.legalSex = observershipAppObject.legalSex;
							}

							if (observershipAppObject.englishProficiency) {
								values.englishProficiency = observershipAppObject.englishProficiency;
							}

							if (observershipAppObject.usmleExams) {
								values.usmleExams = observershipAppObject.usmleExams;
							}

							if (observershipAppObject.currentTitle) {
								values.currentTitle = observershipAppObject.currentTitle.trim();
							}

							if (observershipAppObject.department) {
								values.department = observershipAppObject.department.trim();
							}

							if (observershipAppObject.positionCountry) {
								values.positionCountry = observershipAppObject.positionCountry.trim();
							}

							if (observershipAppObject.currentInstitution) {
								values.currentInstitution = observershipAppObject.currentInstitution.trim();
							}



							if (observershipAppObject.positionStartMonth) {
								values.positionStartMonth = observershipAppObject.positionStartMonth;
							}
							if (observershipAppObject.positionStartYear) {
								values.positionStartYear = observershipAppObject.positionStartYear;
							}


							if (observershipAppObject.positionStartMonth && observershipAppObject.positionStartYear) {
								values.startDate = observershipAppObject.positionStartMonth + "/01/" + observershipAppObject.positionStartYear;
							}

							if (observershipAppObject.preferredDepartment) {
								values.preferredDepartment = observershipAppObject.preferredDepartment.trim();
							}

							if (observershipAppObject.preferredDepartmentOther && otherDept) {
								values.preferredDepartmentOther = observershipAppObject.preferredDepartmentOther.trim();
								values.preferredDepartment = observershipAppObject.preferredDepartmentOther.trim();
							}

							if (observershipAppObject.minDesiredDuration) {
								values.minDesiredDuration = observershipAppObject.minDesiredDuration;
							}

							if (observershipAppObject.maxDesiredDuration) {
								values.maxDesiredDuration = observershipAppObject.maxDesiredDuration;
							}

							if (observershipAppObject.preferredStartMonth && observershipAppObject.preferredStartYear) {
								values.preferredStart = observershipAppObject.preferredStartMonth + "/01/" + observershipAppObject.preferredStartYear;
							}

							if (observershipAppObject.preferredEndMonth && observershipAppObject.preferredEndYear) {
								values.preferredEnd = observershipAppObject.preferredEndMonth + "/01/" + observershipAppObject.preferredEndYear;
							}



							if (observershipAppObject.availableStartMonth && observershipAppObject.availableStartYear) {
								values.availableStart = observershipAppObject.availableStartMonth + "/01/" + observershipAppObject.availableStartYear;
							}

							if (observershipAppObject.availableEndMonth && observershipAppObject.availableEndYear) {
								values.availableEnd = observershipAppObject.availableEndMonth + "/01/" + observershipAppObject.availableEndYear;
							}


							if (observershipAppObject.additionalComments) {
								values.additionalComments = observershipAppObject.additionalComments.trim();
							}

							if (observershipAppObject.termsAndConditions) {
								values.termsAndConditions = observershipAppObject.termsAndConditions;
							}

							if (observershipAppObject.hearAbout) {
								values.hearAbout = observershipAppObject.hearAbout.trim();
							}

							//education section
							if (observershipAppObject.applicantEducation.degreeOne) {
								values.degreeOne = observershipAppObject.applicantEducation.degreeOne.trim();
							}

							if (observershipAppObject.applicantEducation.degreeTwo) {
								values.degreeTwo = observershipAppObject.applicantEducation.degreeTwo.trim();
							}

							if (observershipAppObject.applicantEducation.degreeThree) {
								values.degreeThree = observershipAppObject.applicantEducation.degreeThree.trim();
							}

							if (observershipAppObject.applicantEducation.startMonthDegreeOne && observershipAppObject.applicantEducation.startYearDegreeOne) {
								values.startDateDegreeOne = observershipAppObject.applicantEducation.startMonthDegreeOne + "/01/" + observershipAppObject.applicantEducation.startYearDegreeOne;
							}
							if (observershipAppObject.applicantEducation.startMonthDegreeTwo && observershipAppObject.applicantEducation.startYearDegreeTwo) {
								values.startDateDegreeTwo = observershipAppObject.applicantEducation.startMonthDegreeTwo + "/01/" + observershipAppObject.applicantEducation.startYearDegreeTwo;
							}

							if (observershipAppObject.applicantEducation.startMonthDegreeThree && observershipAppObject.applicantEducation.startYearDegreeThree) {
								values.startDateDegreeThree = observershipAppObject.applicantEducation.startMonthDegreeThree + "/01/" + observershipAppObject.applicantEducation.startYearDegreeThree;
							}


							if (observershipAppObject.applicantEducation.endMonthDegreeOne && observershipAppObject.applicantEducation.endYearDegreeOne) {
								values.endDateDegreeOne = observershipAppObject.applicantEducation.endMonthDegreeOne + "/01/" + observershipAppObject.applicantEducation.endYearDegreeOne;
							}
							if (observershipAppObject.applicantEducation.endMonthDegreeTwo && observershipAppObject.applicantEducation.endYearDegreeTwo) {
								values.endDateDegreeTwo = observershipAppObject.applicantEducation.endMonthDegreeTwo + "/01/" + observershipAppObject.applicantEducation.endYearDegreeTwo;
							}
							if (observershipAppObject.applicantEducation.endMonthDegreeThree && observershipAppObject.applicantEducation.endYearDegreeThree) {
								values.endDateDegreeThree = observershipAppObject.applicantEducation.endMonthDegreeThree + "/01/" + observershipAppObject.applicantEducation.endYearDegreeThree;
							}



							if (observershipAppObject.applicantEducation.institutionOne) {
								values.institutionOne = observershipAppObject.applicantEducation.institutionOne.trim();
							}

							if (observershipAppObject.applicantEducation.institutionTwo) {
								values.institutionTwo = observershipAppObject.applicantEducation.institutionTwo.trim();
							}

							if (observershipAppObject.applicantEducation.institutionThree) {
								values.institutionThree = observershipAppObject.applicantEducation.institutionThree.trim();
							}

							//required documents section

							//Form validation 

							//state is required if country is US (if required, check for empty values or values over maxlength)
							//need to check maxlength here because autocomplete component does not have that prop
							if (isUS && (!values.applicantState || values.applicantState.trim() === "")) {
								errors.applicantState = "State is required";
							}

							if (isUS && (values.applicantState && values.applicantState.length > 35)) {
								errors.applicantState = "Enter a value less than 100 characters";
							}

							if (!isUS && (values.applicantState && values.applicantState.length > 100)) {
								errors.applicantState = "Enter a value less than 100 characters";
							}


							//zip code is required if country is US
							if (isUS && (!values.applicantZipCode || values.applicantZipCode.trim() === "")) {
								errors.applicantZipCode = "Zip/Postal code is required";
							}

							if (!values.address || values.address.trim() === "" || values.address.length > 100) {
								errors.address = "Address is required";
							}

							if (!values.applicantCity || values.applicantCity.trim() === "") {
								errors.applicantCity = "City is required";
							}


							if (!values.applicantPhone) {
								errors.applicantPhone = "Phone number is required";
							} else if (!values.isValidPhoneNumber || values.applicantPhone.length <= 4) {
								errors.applicantPhone = 'Enter a valid phone number';
							}


							if (!values.citizenshipCountry || values.citizenshipCountry.trim() === "" || values.citizenshipCountry.length > 149) {
								errors.citizenshipCountry = "Country of citizenship is required";
							}

							if (otherCitizenshipCountrySelected) {
								if (!values.otherCitizenshipCountry || values.otherCitizenshipCountry === null || values.otherCitizenshipCountry.trim() === "") {
									errors.otherCitizenshipCountry = 'Other country of citizenship is required';
								}

								else if (values.otherCitizenshipCountry.length < 2 || values.otherCitizenshipCountry.length > 149) {
									errors.otherCitizenshipCountry = "Enter a country that is 2 to 150 characters long";
								}
							}


							if (!values.englishProficiency) {
								errors.englishProficiency = "English proficiency level is required";
							}

							if (!values.usmleExams) {
								errors.usmleExams = "Have you either taken or plan to take any of the USMLE examinations? is required";
							}

							if (!values.currentTitle || values.currentTitle.trim() === "") {
								errors.currentTitle = "Professional title is required";
							}

							if (!values.department || values.department.trim() === "") {
								errors.department = "Department is required";
							}

							if (!values.currentInstitution || values.currentInstitution.trim() === "") {
								errors.currentInstitution = "Hospital/Institution is required";
							}

							if (!values.positionCountry || values.positionCountry.trim() === "" || values.positionCountry.length > 99) {
								errors.positionCountry = "Country/Region is required";
							}

							if (otherPositionCountrySelected) {
								if (!values.otherPositionCountry || values.otherPositionCountry === null || values.otherPositionCountry.trim() === "") {
									errors.otherPositionCountry = 'Other country is required';
								}

								else if (values.otherPositionCountry.length < 2 || values.otherPositionCountry.length > 99) {
									errors.otherPositionCountry = "Enter a country that is 2 to 100 characters long";
								}
							}

							//add PositionStartMonth/Year error handling
							if (!values.positionStartMonth || values.positionStartMonth === "") {
								errors.positionStartMonth = "Start Month is required";
							}
							if (!values.positionStartYear || values.positionStartYear === "") {
								errors.positionStartYear = "Start Year is required";
							}

							//NOTE - startDate (for current position) should be in the past 
							let currentDay = new Date();

							let tempPreferredStart = null;
							let tempPreferredEnd = null;
							let tempAvailableStart = null;
							let tempAvailableEnd = null;

							let tempStartDateDegreeOne = null;
							let tempEndDateDegreeOne = null;

							let tempStartDateDegreeTwo = null;
							let tempEndDateDegreeTwo = null;

							let tempStartDateDegreeThree = null;
							let tempEndDateDegreeThree = null;

							currentDay.setHours(0, 0, 0, 0);



							if (values.startDate) {
								let tempStartDate = new Date(values.startDate);
								tempStartDate.setHours(0, 0, 0, 0);
								if (tempStartDate > currentDay) {
									errors.positionStartMonth = "Enter a date in the past";
									errors.positionStartYear = "Enter a date in the past";
								}
							}



							//Validation for education section - only the first degree is required, per stakeholders 
							if (!values.degreeOne || values.degreeOne.trim() === "") {
								errors.degreeOne = "Degree #1 is required";
							}

							if (!values.institutionOne || values.institutionOne.trim() === "") {
								errors.institutionOne = "Institution #1 is required";
							}

							if (!values.startMonthDegreeOne || values.startMonthDegreeOne === "") {
								errors.startMonthDegreeOne = "Start Month is required";
							}
							if (!values.startYearDegreeOne || values.startYearDegreeOne === "") {
								errors.startYearDegreeOne = "Start Year is required";
							}
							if (!values.endMonthDegreeOne || values.endMonthDegreeOne === "") {
								errors.endMonthDegreeOne = "End Month is required";
							}
							if (!values.endYearDegreeOne || values.endYearDegreeOne === "") {
								errors.endYearDegreeOne = "End Year is required";
							}

							if (values.startDateDegreeOne) {
								tempStartDateDegreeOne = new Date(values.startDateDegreeOne);
								tempStartDateDegreeOne.setHours(0, 0, 0, 0);
								if (tempStartDateDegreeOne > currentDay) {
									errors.startMonthDegreeOne = "Enter a date in the past";
									errors.startYearDegreeOne = "Enter a date in the past";
								}
							}
							if (values.endDateDegreeOne) {
								tempEndDateDegreeOne = new Date(values.endDateDegreeOne);
								tempEndDateDegreeOne.setHours(0, 0, 0, 0);
								if (tempEndDateDegreeOne > currentDay) {
									errors.endMonthDegreeOne = "Enter a date in the past";
									errors.endYearDegreeOne = "Enter a date in the past";
								}
							}

							if (values.startDateDegreeOne && values.endDateDegreeOne && tempStartDateDegreeOne > tempEndDateDegreeOne) {
								errors.endMonthDegreeOne = "Enter a date after Start date";
								errors.endYearDegreeOne = "Enter a date after Start date";

							}


							if (values.startDateDegreeTwo) {
								tempStartDateDegreeTwo = new Date(values.startDateDegreeTwo);
								tempStartDateDegreeTwo.setHours(0, 0, 0, 0);
								if (tempStartDateDegreeTwo > currentDay) {
									errors.startMonthDegreeTwo = "Enter a date in the past";
									errors.startYearDegreeTwo = "Enter a date in the past";
								}
							}
							if (values.endDateDegreeTwo) {
								tempEndDateDegreeTwo = new Date(values.endDateDegreeTwo);
								tempEndDateDegreeTwo.setHours(0, 0, 0, 0);
								if (tempEndDateDegreeTwo > currentDay) {
									errors.endMonthDegreeTwo = "Enter a date in the past";
									errors.endYearDegreeTwo = "Enter a date in the past";
								}
							}

							if (values.startDateDegreeTwo && values.endDateDegreeTwo && tempStartDateDegreeTwo > tempEndDateDegreeTwo) {
								errors.endMonthDegreeTwo = "Enter a date after Start date";
								errors.endYearDegreeTwo = "Enter a date after Start date";

							}


							if (values.startDateDegreeThree) {
								tempStartDateDegreeThree = new Date(values.startDateDegreeThree);
								tempStartDateDegreeThree.setHours(0, 0, 0, 0);
								if (tempStartDateDegreeThree > currentDay) {
									errors.startMonthDegreeThree = "Enter a date in the past";
									errors.startYearDegreeThree = "Enter a date in the past";
								}
							}
							if (values.endDateDegreeThree) {
								tempEndDateDegreeThree = new Date(values.endDateDegreeThree);
								tempEndDateDegreeThree.setHours(0, 0, 0, 0);
								if (tempEndDateDegreeThree > currentDay) {
									errors.endMonthDegreeThree = "Enter a date in the past";
									errors.endYearDegreeThree = "Enter a date in the past";
								}
							}

							if (values.startDateDegreeThree && values.endDateDegreeThree && tempStartDateDegreeThree > tempEndDateDegreeThree) {
								errors.endMonthDegreeThree = "Enter a date after Start date";
								errors.endYearDegreeThree = "Enter a date after Start date";

							}






							if (values.startDateDegreeOne && values.endDateDegreeOne) {
								let applicantEducation = observershipAppObject.applicantEducation;
								let educationDatesDegreeOne = values.startDateDegreeOne + " - " + values.endDateDegreeOne;
								values.educationDatesDegreeOne = educationDatesDegreeOne;
								setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, educationDatesDegreeOne: educationDatesDegreeOne } });
							}

							if (values.startDateDegreeTwo && values.endDateDegreeTwo) {
								let applicantEducation = observershipAppObject.applicantEducation;
								let educationDatesDegreeTwo = values.startDateDegreeTwo + " - " + values.endDateDegreeTwo;
								values.educationDatesDegreeTwo = educationDatesDegreeTwo;
								setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, educationDatesDegreeTwo: educationDatesDegreeTwo } });
							}

							if (values.startDateDegreeThree && values.endDateDegreeThree) {
								let applicantEducation = observershipAppObject.applicantEducation;
								let educationDatesDegreeThree = values.startDateDegreeThree + " - " + values.endDateDegreeThree;
								values.educationDatesDegreeThree = educationDatesDegreeThree;
								setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, educationDatesDegreeThree: educationDatesDegreeThree } });
							}

							//Checking to make sure, if one of degree two information is entered
							//all associated information (degree, institution, dates) are also entered				
							let degreeTwoFieldsRequired = !isEmptyString(values.degreeTwo) || !isEmptyString(values.institutionTwo) ||
								!isEmptyDate(values.startDateDegreeTwo) || !isEmptyDate(values.endDateDegreeTwo);


							setDegreeTwoReq(degreeTwoFieldsRequired);
							setInstitutionTwoReq(degreeTwoFieldsRequired);
							setStartDateDegreeTwoReq(degreeTwoFieldsRequired);
							setEndDateDegreeTwoReq(degreeTwoFieldsRequired);

							if (degreeTwoFieldsRequired) {
								if (!values.degreeTwo || isEmptyString(values.degreeTwo)) {
									errors.degreeTwo = "Degree #2 is required";
								}

								if (!values.institutionTwo || isEmptyString(values.institutionTwo)) {
									errors.institutionTwo = "Institution #2 is required";
								}




								if (!values.startMonthDegreeTwo || values.startMonthDegreeTwo.trim() === "") {
									errors.startMonthDegreeTwo = "Start Month is required";
								}
								if (!values.startYearDegreeTwo || values.startYearDegreeTwo.trim() === "") {
									errors.startYearDegreeTwo = "Start Year is required";
								}
								if (!values.endMonthDegreeTwo || values.endMonthDegreeTwo.trim() === "") {
									errors.endMonthDegreeTwo = "End Month is required";
								}
								if (!values.endYearDegreeTwo || values.endYearDegreeTwo.trim() === "") {
									errors.endYearDegreeTwo = "End Year is required";
								}


							}


							//degree three section
							let degreeThreeFieldsRequired = !isEmptyString(values.degreeThree) || !isEmptyString(values.institutionThree) ||
								!isEmptyDate(values.startDateDegreeThree) || !isEmptyDate(values.endDateDegreeThree);


							setDegreeThreeReq(degreeThreeFieldsRequired);
							setInstitutionThreeReq(degreeThreeFieldsRequired);
							setStartDateDegreeThreeReq(degreeThreeFieldsRequired);
							setEndDateDegreeThreeReq(degreeThreeFieldsRequired);

							if (degreeThreeFieldsRequired) {
								if (!values.degreeThree || isEmptyString(values.degreeThree)) {
									errors.degreeThree = "Degree #3 is required";
								}

								if (!values.institutionThree || isEmptyString(values.institutionThree)) {
									errors.institutionThree = "Institution #3 is required";
								}



								if (!values.startMonthDegreeThree || values.startMonthDegreeThree.trim() === "") {
									errors.startMonthDegreeThree = "Start Month is required";
								}
								if (!values.startYearDegreeThree || values.startYearDegreeThree.trim() === "") {
									errors.startYearDegreeThree = "Start Year is required";
								}
								if (!values.endMonthDegreeThree || values.endMonthDegreeThree.trim() === "") {
									errors.endMonthDegreeThree = "End Month is required";
								}
								if (!values.endYearDegreeThree || values.endYearDegreeThree.trim() === "") {
									errors.endYearDegreeThree = "End Year is required";
								}
							}


							if (!observershipAppObject.preferredDepartment || observershipAppObject.preferredDepartment === "") //!values.preferredDepartment
							{
								errors.preferredDepartment = "Department/Subspecialty is required";
							}

							else if (observershipAppObject.preferredDepartment === "Other") {
								//errors.preferredDepartment = "";
								errors.preferredDepartmentOther = "Other Department/Subspecialty is required";
							}

							if (!values.minDesiredDuration) {
								errors.minDesiredDuration = "Minimum desired duration is required";
							}

							if (!values.maxDesiredDuration) {
								errors.maxDesiredDuration = "Maximum desired duration is required";
							}

							//max duration must be greater than min duration
							if (!validateDurationsCompare(values.maxDesiredDuration, values.minDesiredDuration)) {
								errors.maxDesiredDuration = "Enter a duration that is more than your Minimum desired duration";
								errors.minDesiredDuration = "Enter a duration that is less than your Maximum desired duration";
							}

							//Preferred start must be before preferred end
							//Preferred start/end must be in the future

							if (values.preferredStart && values.preferredEnd) {

								let preferredMonths = values.preferredStart + " - " + values.preferredEnd;
								values.preferredMonths = preferredMonths;
								setObservershipAppObject({ ...observershipAppObject, preferredMonths: preferredMonths });
							}



							if (!values.preferredStartMonth || values.preferredStartMonth.trim() === "") {
								errors.preferredStartMonth = "Preferred Start Month is required";
							}
							if (!values.preferredStartYear || values.preferredStartYear.trim() === "") {
								errors.preferredStartYear = "Preferred Start Year is required";
							}
							if (!values.preferredEndMonth || values.preferredEndMonth.trim() === "") {
								errors.preferredEndMonth = "Preferred End Month is required";
							}
							if (!values.preferredEndYear || values.preferredEndYear.trim() === "") {
								errors.preferredEndYear = "Preferred End Year is required";
							}

							if (values.preferredStart) {
								tempPreferredStart = new Date(values.preferredStart);
								tempPreferredStart.setHours(0, 0, 0, 0);
								if (tempPreferredStart < currentDay) {
									errors.preferredStartMonth = "Enter a date in the future";
									errors.preferredStartYear = "Enter a date in the future";
								}
							}

							if (values.preferredEnd) {
								tempPreferredEnd = new Date(values.preferredEnd);
								tempPreferredEnd.setHours(0, 0, 0, 0);
								if (tempPreferredEnd < currentDay) {
									errors.preferredEndMonth = "Enter a date in the future";
									errors.preferredEndYear = "Enter a date in the future";
								}
							}


							if (values.preferredStart && tempPreferredStart.getFullYear() > currentDay.getFullYear() + 2) {
								errors.preferredStartMonth = "Enter a date that is within 2 years of today’s date";
								errors.preferredStartYear = "Enter a date that is within 2 years of today’s date";
							}


							if (values.preferredEnd && values.preferredStart && tempPreferredEnd < tempPreferredStart) {
								errors.preferredEndMonth = "Enter a date after Preferred start date";
								errors.preferredEndYear = "Enter a date after Preferred start date";
							}

							if (values.preferredEnd && tempPreferredEnd.getFullYear() > currentDay.getFullYear() + 2) {
								errors.preferredEndMonth = "Enter a date that is within 2 years of today’s date";
								errors.preferredEndYear = "Enter a date that is within 2 years of today’s date";
							}

							//Available start must be before available end
							//Available start/end must be in the future 
							if (values.availableStart && values.availableEnd) {

								let availableMonths = values.availableStart + " - " + values.availableEnd;
								values.availableMonths = availableMonths;
								setObservershipAppObject({ ...observershipAppObject, availableMonths: availableMonths });
							}

							if (!values.availableStartMonth || values.availableStartMonth.trim() === "") {
								errors.availableStartMonth = "Available Start Month is required";
							}
							if (!values.availableStartYear || values.availableStartYear.trim() === "") {
								errors.availableStartYear = "Available Start Year is required";
							}
							if (!values.availableEndMonth || values.availableEndMonth.trim() === "") {
								errors.availableEndMonth = "Available End Month is required";
							}
							if (!values.availableEndYear || values.availableEndYear.trim() === "") {
								errors.availableEndYear = "Available End Year is required";
							}

							if (values.availableStart) {
								tempAvailableStart = new Date(values.availableStart);
								tempAvailableStart.setHours(0, 0, 0, 0);
								if (tempAvailableStart < currentDay) {
									errors.availableStartMonth = "Enter a date in the future";
									errors.availableStartYear = "Enter a date in the future";
								}
							}

							if (values.availableEnd) {
								tempAvailableEnd = new Date(values.availableEnd);
								tempAvailableEnd.setHours(0, 0, 0, 0);
								if (tempAvailableEnd < currentDay) {
									errors.availableEndMonth = "Enter a date in the future";
									errors.availableEndYear = "Enter a date in the future";
								}
							}

							if (values.availableStart && tempAvailableStart.getFullYear() > currentDay.getFullYear() + 2) {
								errors.availableStartMonth = "Enter a date that is within 2 years of today’s date";
								errors.availableStartYear = "Enter a date that is within 2 years of today’s date";
							}


							if (values.availableEnd && values.availableStart && tempAvailableEnd < tempAvailableStart) {
								errors.availableEndMonth = "Enter a date after Available start date";
								errors.availableEndYear = "Enter a date after Available start date";
							}

							if (values.availableEnd && tempAvailableEnd.getFullYear() > currentDay.getFullYear() + 2) {
								errors.availableEndMonth = "Enter a date that is within 2 years of today’s date";
								errors.availableEndYear = "Enter a date that is within 2 years of today’s date";
							}





							if (!values.termsAndConditions || values.termsAndConditions.length === 0) {
								errors.termsAndConditions = "Terms & conditions agreement is required";
							}

							if (!observershipAppObject.hearAbout || observershipAppObject.hearAbout === "") {
								errors.hearAbout = "How did you hear about the Observership Program? is required";
							}
							else if (observershipAppObject.hearAbout === "Other (please specify)") {
								errors.hearAboutText = "Please indicate how you heard about the Observership Program is required";
							} else if (observershipAppObject.hearAbout === "Boston Children's Hospital Staff") {
								errors.hearAboutText = "Hospital staff name is required";
							}


							// using values.cvUploaded doesn't work. we have to use a flag to do the check
							if (curriculumVitaeUploaded !== true) {
								errors.cvUploaded = cvErrorMessage;
							}

							// using values.sopUploaded doesn't work. we have to use a flag to do the check
							if (statementOfPurposeUploaded !== true) {
								errors.sopUploaded = sopErrorMessage;
							}

							// using values.losUploaded doesn't work. we have to use a flag to do the check
							if (letterOfSupportUploaded !== true) {
								errors.losUploaded = losErrorMessage;
							}

							// using values.rPhotographUploaded doesn't work. we have to use a flag to do the check
							if (recentPhotographUploaded !== true) {
								errors.rPhotographUploaded = rpErrorMessage;
							}
						}

						if (Object.keys(errors).length > 0) {
							setFormikError(true);
						} else {
							setFormikError(false);
						}
						return errors;
					}}

					onSubmit={(values, { setSubmitting, resetForm }) => {

						// update derived values before save, otherwise the values might be null
						// startDate for current position
						const startDate = observershipAppObject.positionStartMonth && observershipAppObject.positionStartYear
							? `${observershipAppObject.positionStartMonth}/01/${observershipAppObject.positionStartYear}`
							: null;
						//preferredMonths
						const preferredMonths = observershipAppObject.preferredStartMonth && observershipAppObject.preferredStartYear && observershipAppObject.preferredEndMonth && observershipAppObject.preferredEndYear
							? `${observershipAppObject.preferredStartMonth}/01/${observershipAppObject.preferredStartYear} - ${observershipAppObject.preferredEndMonth}/01/${observershipAppObject.preferredEndYear}`
							: null;
						//availableMonths
						const availableMonths = observershipAppObject.availableStartMonth && observershipAppObject.availableStartYear && observershipAppObject.availableEndMonth && observershipAppObject.availableEndYear
							? `${observershipAppObject.availableStartMonth}/01/${observershipAppObject.availableStartYear} - ${observershipAppObject.availableEndMonth}/01/${observershipAppObject.availableEndYear}`
							: null;
						// Update state first, then save
						const updatedAppObject = {
							...observershipAppObject,
							startDate: startDate,
							preferredMonths: preferredMonths,
							availableMonths: availableMonths,
						};

						setObservershipAppObject(updatedAppObject);

						setTimeout(() => {
							saveApplication(values, updatedAppObject);
							setSubmitting(false);
							//hide form once submitted
							setSaving(true);
						}, 1);
					}}
				>
					{({
						values /* all data need to run the valdation*/,
						errors /* all error strings */,
						touched /* all field touch event  */,
						handleChange /* value change event handler */,
						handleBlur /* onBlur event handler */,
						handleSubmit /* for submit button */,
						isSubmitting /* for submit button */,
						isValid /* for submit button */,
						dirty /* for submit button */,
						validateForm,
						setFieldValue,
						setFieldError
						/* and other goodies */
					}) => (
						<form onSubmit={handleSubmit} onKeyDown={(e) => checkKeyDown(e)} noValidate>

							<div>
								<div id="completed" className={applicationId > 0 && !applicationCompleted ? 'show_div' : 'hide_div'}>
									<div id="alreadySubmittedDiv" className="div_1_col">
										<Ribbon label="SUBMITTED" status={"checkmark"} subheader={""} content={alreadySubmittedContent} />
									</div>
								</div>

								<div>
									<div id="submitSuccess" className={(saveSuccess ? 'show_div' : 'hide_div')}>
										<div id="successDiv" className="div_3_col">
											<Ribbon label={"Submitted"} status={"checkmark"} subheader={""} content={successMsgContent} />
										</div>
									</div>
									<div id="submitFailed" className={(saveFailed ? 'show_div' : 'hide_div')}>
										<div id="failDiv" className="div_1_col">
											<Ribbon label={responseError} status={"error"} subheader={""} content={""} />
										</div>
									</div>
									<div id="formikErrors" className={(formikError && formSubmitted ? 'show_div' : 'hide_div')}>
										<div id="formikFailDiv" className="div_1_col">
											<Ribbon label={"REVIEW ISSUES BELOW"} status={"error"} subheader={""} content={""} />
										</div>
									</div>
								</div>
								<div className={((applicationId > 0 && !applicationCompleted) || saveSuccess ? 'hide_div' : 'show_div')}>
									<div id="headerDiv" className="div_1_col">
										<div className="breadcrumbLink"><a href={dashboardUrl} onClick={(e) => { returnToDashboard(); }}>Dashboard</a></div>
										<div className="page_title padding-bottom-30">Observership Program Application</div>
									</div>
									<div id="divPageInfo" className="div_3_col padding-bottom-30 normal_txt">We recommend reviewing this form before starting to ensure that you have the information required to submit your application. For security reasons your session will expire if this page remains idle for more than 60 minutes.</div>

									{/* ------ CONTACT INFORMATION SECTION ----------- */}
									<CollapseBar
										id={"cb1"}
										title={"Contact Information"}
										showNewLink={false}
										showMoveTop={false}
										showCollapseBT={false}
										initStateExpand={true}
									/>

									<div id="theDiv2Hide5" className="div_3_col">
										<hr />
										<div>
											<div class="dataGrid">
												<div class="dataGrid__content">First name</div>
												<div style={dataGridWithWidth} class="dataGrid__content dataGrid__content--string">{currentContext.userProfile.firstName}</div>
											</div>
											<hr />
											<div class="dataGrid">
												<div class="dataGrid__content">Last name</div>
												<div style={dataGridWithWidth} class="dataGrid__content dataGrid__content--string">{currentContext.userProfile.lastName}</div>
											</div>
											<hr />
											<div class="dataGrid">
												<div class="dataGrid__content">Email</div>
												<div style={dataGridWithWidth} class="dataGrid__content dataGrid__content--string">{currentContext.userProfile.email}</div>
											</div>
											<hr />
											<div class="dataGrid">
												<div class="dataGrid__content">Country/Region</div>
												<div style={dataGridWithWidth} class="dataGrid__content dataGrid__content--string">{currentContext.userProfile.country}</div>
											</div>
										</div>
										<hr />
										<div className="padding-top-10"></div>

										<InputTxt
											id="address" // need match value name
											name="address" // name will not work for formik in this case for input box
											labelText={"Address"}
											isRequired={true}
											maxLength={100}
											// show error and error message is control by formik    
											errorMessage={errors.address}
											hasError={touched.address && errors.address}
											// onchange and onblur is return event, handle by formik
											onChange={handleChange}
											onBlur={handleBlur}
											// setup formik value
											value={observershipAppObject.address}
											getTextString={(address) => setObservershipAppObject({ ...observershipAppObject, address: address.trim() })}
										/>
										<InputTxt
											id="addressTwo" // need match value name
											name="addressTwo" // name will not work for formik in this case for input box
											labelText={"Apartment, suite, unit, floor, etc."}
											isRequired={false}
											maxLength={100}
											// show error and error message is control by formik    
											errorMessage={errors.addressTwo}
											hasError={touched.addressTwo && errors.addressTwo}
											// onchange and onblur is return event, handle by formik
											onChange={handleChange}
											onBlur={handleBlur}
											// setup formik value
											value={observershipAppObject.addressTwo}
											getTextString={(addressTwo) => setObservershipAppObject({ ...observershipAppObject, addressTwo: addressTwo.trim() })}
										/>

										<InputTxt
											id="applicantCity" // need match value name
											name="applicantCity" // name will not work for formik in this case for input box
											labelText={"City"}
											isRequired={true}
											maxLength={50}
											// show error and error message is control by formik    
											errorMessage={errors.applicantCity}
											hasError={touched.applicantCity && errors.applicantCity}
											// onchange and onblur is return event, handle by formik
											onChange={handleChange}
											onBlur={handleBlur}
											// setup formik value
											value={observershipAppObject.applicantCity}
											getTextString={(applicantCity) => setObservershipAppObject({ ...observershipAppObject, applicantCity: applicantCity.trim() })}
										/>
										<div className="horizontal_div">
											<AutoComplete
												id="applicantState"
												labelText={"State/Province"}
												dataSet={isUS ? "state" : ""}
												isRequired={isUS ? true : false} // add required star
												isDisabled={false} // disable the inputbox
												value={values.applicantState} // formik initialValues
												hasError={touched.applicantState && errors.applicantState}
												errorMessage={errors.applicantState}
												onFocus={(e) => {
													touched.applicantState = e;
												}}

												onChange={(e) => {
													setObservershipAppObject({ ...observershipAppObject, applicantState: e.trim() })
													values.applicantState = e;
													touched.applicantState = true;
													validateForm();
												}}

												onBlur={(e) => {
													setObservershipAppObject({ ...observershipAppObject, applicantState: e.trim() });
													values.applicantState = e;
													touched.applicantState = true;
													validateForm();
												}}
											/>
											<InputTxt
												id="applicantZipCode" // need match value name
												name="applicantZipCode" // name will not work for formik in this case for input box
												labelText={"ZIP/Postal code"}
												isRequired={isUS}
												maxLength={50}
												// show error and error message is control by formik    
												errorMessage={errors.applicantZipCode}
												hasError={touched.applicantZipCode && errors.applicantZipCode}
												// onchange and onblur is return event, handle by formik
												onChange={handleChange}
												onBlur={handleBlur}
												// setup formik value
												value={observershipAppObject.applicantZipCode}
												getTextString={(applicantZipCode) => setObservershipAppObject({ ...observershipAppObject, applicantZipCode: applicantZipCode.trim() })}
											/>
										</div>
										<PhoneInput
											id="applicantPhone"
											name="applicantPhone"
											labelText={"Phone number"}
											isRequired={true} // add requird star
											isDisabled={false} // disable the inputbox
											showFlag={true} // without flag, US number only
											helpMessage="Select the flag icon to choose your country, then enter your phone number"
											value={observershipAppObject.applicantPhone}
											errorMessage={errors.applicantPhone}
											hasError={touched.applicantPhone && errors.applicantPhone}
											onChange={(applicantPhone) => setObservershipAppObject({ ...observershipAppObject, applicantPhone: applicantPhone ? applicantPhone.trim() : "" })}
											onBlur={(applicantPhone) => {
												if (applicantPhone.e) {
													setObservershipAppObject({ ...observershipAppObject, applicantPhone: applicantPhone.e.trim() });
												} else {
													setObservershipAppObject({ ...observershipAppObject, applicantPhone: "" });
												}
												//the e.phoneNumberHasError is mis-named, it is true if the number is correct 
												values.isValidPhoneNumber = applicantPhone.phoneNumberHasError;
												touched.applicantPhone = true;
												validateForm();
											}}
											onFocus={(e) => { touched.applicantPhone = e }}
										/>

									</div>

									{/* -----DEMOGRAPHIC INFORMATION SECTION--------- */}
									<CollapseBar
										id={"cb2"}
										title={"Demographic Information"}
										showNewLink={false}
										showMoveTop={false}
										showCollapseBT={false}
										initStateExpand={true}
									/>

									<div id="theDiv3Hide5" className="div_3_col">
										<div>
											<Dropdown
												id="citizenshipCountry"
												name="citizenshipCountry"
												label="Country of citizenship"
												isRequired={true}
												isDisabled={false}
												helpMessage=""
												data={COUNTRIES_LIST}
												selectedItem={values.citizenshipCountry}
												value={values.citizenshipCountry}
												disableDefault={false}
												getSelectedValue={(citizenshipCountry) => { setObservershipAppObject({ ...observershipAppObject, citizenshipCountry: citizenshipCountry.value }); }}
												errorMessage={errors.citizenshipCountry}
												hasError={touched.citizenshipCountry && errors.citizenshipCountry}
												onChange={(citizenshipCountry) => {
													errors.citizenshipCountry = "";
													setOtherCitizenshipCountrySelected(false);
													values.otherCitizenshipCountry = null;
													if (citizenshipCountry) {
														values.citizenshipCountry = citizenshipCountry.value;
														if (citizenshipCountry.value === "Other") {
															setOtherCitizenshipCountrySelected(true);
															setObservershipAppObject({ ...observershipAppObject, citizenshipCountry: "" });
														} else {
															setObservershipAppObject({ ...observershipAppObject, citizenshipCountry: citizenshipCountry.value });
														}
													} else {
														values.citizenshipCountry = null;
														setObservershipAppObject({ ...observershipAppObject, citizenshipCountry: null });
													}
												}}
												onFocus={(e) => {
													touched.citizenshipCountry = e;
												}}
												onBlur={(e) => handleBlur(e)}

											/>
										</div>


										<div className={(otherCitizenshipCountrySelected ? 'show_div' : 'hide_div')}>

											<InputTxt
												id="otherCitizenshipCountry"
												name="otherCitizenshipCountry"
												labelText="Other country/region"
												helpMessage=""
												isRequired={otherCitizenshipCountrySelected ? true : false}
												maxLength={150}
												errorMessage={errors.otherCitizenshipCountry}
												hasError={touched.otherCitizenshipCountry && errors.otherCitizenshipCountry}
												onChange={handleChange}
												onBlur={handleBlur}
												value={values.otherCitizenshipCountry}
												getTextString={(otherCitizenshipCountry) => setObservershipAppObject({ ...observershipAppObject, citizenshipCountry: otherCitizenshipCountry.trim() })}
											/>
										</div>


										<RadioButtons
											id="legalSex"
											label={"Legal sex"}
											name="legalSex"
											// init data array setup radio buttons
											data={sex_radios}
											isRequired={false}
											layoutVertical={false}
											selectedItem={observershipAppObject.legalSex}
											value={(e) => {
												//no need to set anything in value, because it is being set in change
											}}
											onChange={(e) => {

												values.legalSex = e;
												setObservershipAppObject({ ...observershipAppObject, legalSex: e });
											}}
											// if touched and has error
											hasError={touched.legalSex && errors.legalSex}
											// get error message from errors
											errorMessage={errors.legalSex}
											// on forcus, change touched to true
											onFocus={(e) => { touched.legalSex = e; }}

										/>

										<RadioButtons
											id="englishProficiency"
											label={"English proficiency level"}
											name="englishProficiency"
											// init data array setup radio buttons
											data={englishProficiencyLevel}
											isRequired={true}
											layoutVertical={false}
											selectedItem={observershipAppObject.englishProficiency}
											helpMessage={"If available, please share any English proficiency exam scores in the “Additional comments” at the end."}
											value={(e) => {
												//no need to set anything in value, because it is being set in change
											}}
											onChange={(e) => {
												errors.englishProficiency = "";
												setObservershipAppObject({ ...observershipAppObject, englishProficiency: e });
											}}
											// if touched and has error
											hasError={touched.englishProficiency && errors.englishProficiency}
											// get error message from errors
											errorMessage={errors.englishProficiency}
											// on forcus, change touched to true
											onFocus={(e) => { touched.englishProficiency = e; }}
											onBlur={(e) => {
												touched.legalSex = e;
												validateForm();
											}}
										/>


										<RadioButtons
											id="usmleExams"
											label={"Have you either taken or plan to take any of the USMLE examinations?"}
											name="usmleExams"
											// init data array setup radio buttons
											data={usmleYesNo}
											isRequired={true}
											layoutVertical={false}
											selectedItem={observershipAppObject.usmleExams}
											value={(e) => {
												//no need to set anything in value, because it is being set in change
											}}
											onChange={(e) => {
												errors.usmleExams = "";
												setObservershipAppObject({ ...observershipAppObject, usmleExams: e });
											}}
											// if touched and has error
											hasError={touched.usmleExams && errors.usmleExams}
											// get error message from errors
											errorMessage={errors.usmleExams}
											// on forcus, change touched to true
											onFocus={(e) => { touched.usmleExams = e; }}
											onBlur={(e) => {
												touched.legalSex = e;
												validateForm();
											}}
										/>

									</div>
									{/* ----------EDUCATION SECTION --------- */}
									<CollapseBar
										id={"cb3"}
										title={"Education"}
										showNewLink={false}
										showMoveTop={false}
										showCollapseBT={false}
										initStateExpand={true}
									/>

									<div id="theDiv4Hide5" className="div_3_col">
										<div class="normal_txt padding-bottom-20">
											Please list your degrees in reverse chronological order, listing your most recent degree first. Please enter academic degrees and postdoctoral training programs including residency and fellowships.
										</div>
										<h3 className="color--boston-pink padding-top-30 padding-bottom-20">Degree #1</h3>
										<div className="horizontal_div">
											<InputTxt
												id="degreeOne" // need match value name
												name="degreeOne" // name will not work for formik in this case for input box
												labelText={"Degree #1"}
												isRequired={true}
												// show error and error message is control by formik    
												errorMessage={errors.degreeOne}
												maxLength={100}
												hasError={touched.degreeOne && errors.degreeOne}
												// onchange and onblur is return event, handle by formik
												onChange={handleChange}
												onBlur={handleBlur}
												// setup formik value
												getTextString={(degreeOne) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, degreeOne: degreeOne.trim() } })
												}
												}
												value={values.degreeOne}
											/>

											<InputTxt
												id="institutionOne" // need match value name
												name="institutionOne" // name will not work for formik in this case for input box
												labelText={"Institution"}
												isRequired={true}
												// show error and error message is control by formik    
												errorMessage={errors.institutionOne}
												maxLength={50}
												hasError={touched.institutionOne && errors.institutionOne}
												// onchange and onblur is return event, handle by formik
												onChange={handleChange}
												onBlur={handleBlur}
												// setup formik value
												getTextString={(institutionOne) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, institutionOne: institutionOne.trim() } })
												}
												}
												value={values.institutionOne}
											/>
										</div>

										<div class="normal_txt padding-bottom-20">
											Dates Attended
										</div>

										{/* Replace MonthYear comp with Dropdowns: startMonthDegreeOne and startYearDegreeOne for startDateDegreeOne --JWM-3344 Missing/Invalid Dates  */}
										<div className="horizontal_div padding-bottom-20">
											<Dropdown
												id="startMonthDegreeOne"
												name="startMonthDegreeOne"
												label="Start Month"
												isRequired={true}
												isDisabled={false}
												helpMessage=""
												data={MONTHS}
												selectedItem={values.startMonthDegreeOne || ''}

												disableDefault={false}
												getSelectedValue={(startMonthDegreeOne) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, startMonthDegreeOne: startMonthDegreeOne.value } });
												}}
												onChange={(month) => {
													errors.startMonthDegreeOne = "";
													let applicantEducation = observershipAppObject.applicantEducation;
													if (month) {
														values.startMonthDegreeOne = month.value;
														setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, startMonthDegreeOne: month.value } });

													} else {
														values.startMonthDegreeOne = "";
														values.startDateDegreeOne = "";
														values.educationDatesDegreeOne = "";
														setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, startMonthDegreeOne: null, startDateDegreeOne: null, educationDatesDegreeOne: null } });
													}

												}}

												hasError={touched.startMonthDegreeOne && errors.startMonthDegreeOne}
												errorMessage={errors.startMonthDegreeOne}

												onBlur={(e) => handleBlur(e)}
												// onFocus event return TRUE, set touched to true, this can show/hide error message
												onFocus={(e) => {
													touched.startMonthDegreeOne = e;
												}}

												// update formik value
												value={(month) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													values.startMonthDegreeOne = month.value;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, startMonthDegreeOne: month.value } });
												}}

											/>

											<Dropdown
												id="startYearDegreeOne"
												name="startYearDegreeOne"
												label="Start Year"
												isRequired={true}
												isDisabled={false}
												helpMessage=""
												data={yearsforDegree}
												selectedItem={values.startYearDegreeOne || ''}
												disableDefault={false}
												getSelectedValue={(startYearDegreeOne) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, startYearDegreeOne: startYearDegreeOne.value } });
												}}
												onChange={(year) => {
													errors.startYearDegreeOne = "";
													let applicantEducation = observershipAppObject.applicantEducation;
													if (year) {
														values.startYearDegreeOne = year.value;
														setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, startYearDegreeOne: year.value } });

													} else {
														values.startYearDegreeOne = "";
														values.startDateDegreeOne = "";
														values.educationDatesDegreeOne = "";
														setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, startYearDegreeOne: null, startDateDegreeOne: null, educationDatesDegreeOne: null } });
													}

												}}

												hasError={touched.startYearDegreeOne && errors.startYearDegreeOne}
												errorMessage={errors.startYearDegreeOne}

												onBlur={(e) => handleBlur(e)}
												// onFocus event return TRUE, set touched to true, this can show/hide error message
												onFocus={(e) => {
													touched.startYearDegreeOne = e;
												}}

												// update formik value
												value={(year) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													values.startYearDegreeOne = year.value;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, startYearDegreeOne: year.value } });
												}}

											/>


										</div>

										{/* Dropdowns endMonthDegreeOne and endYearDegreeOne for endDateDegreeOne --JWM-3344 Missing/Invalid Dates */}
										<div className="horizontal_div padding-bottom-20">

											<Dropdown
												id="endMonthDegreeOne"
												name="endMonthDegreeOne"
												label="End Month"
												isRequired={true}
												isDisabled={false}
												helpMessage=""
												data={MONTHS}
												selectedItem={values.endMonthDegreeOne || ''}

												disableDefault={false}
												getSelectedValue={(endMonthDegreeOne) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, endMonthDegreeOne: endMonthDegreeOne.value } });
												}}
												onChange={(month) => {
													errors.endMonthDegreeOne = "";
													let applicantEducation = observershipAppObject.applicantEducation;
													if (month) {
														values.endMonthDegreeOne = month.value;
														setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, endMonthDegreeOne: month.value } });

													} else {
														values.endMonthDegreeOne = "";
														values.endDateDegreeOne = "";
														values.educationDatesDegreeOne = "";

														setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, endMonthDegreeOne: null, endDateDegreeOne: null, educationDatesDegreeOne: null } });
													}

												}}

												hasError={touched.endMonthDegreeOne && errors.endMonthDegreeOne}
												errorMessage={errors.endMonthDegreeOne}

												onBlur={(e) => handleBlur(e)}
												// onFocus event return TRUE, set touched to true, this can show/hide error message
												onFocus={(e) => {
													touched.endMonthDegreeOne = e;
												}}

												// update formik value
												value={(month) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													values.endMonthDegreeOne = month.value;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, endMonthDegreeOne: month.value } });
												}}

											/>

											<Dropdown
												id="endYearDegreeOne"
												name="endYearDegreeOne"
												label="End Year"
												isRequired={true}
												isDisabled={false}
												helpMessage=""
												data={yearsforDegree}
												selectedItem={values.endYearDegreeOne || ''}
												disableDefault={false}
												getSelectedValue={(endYearDegreeOne) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, endYearDegreeOne: endYearDegreeOne.value } });
												}}
												onChange={(year) => {
													errors.endYearDegreeOne = "";
													let applicantEducation = observershipAppObject.applicantEducation;
													if (year) {
														values.endYearDegreeOne = year.value;
														setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, endYearDegreeOne: year.value } });

													} else {
														values.endYearDegreeOne = "";
														values.endDateDegreeOne = "";
														values.educationDatesDegreeOne = "";
														setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, endYearDegreeOne: null, endDateDegreeOne: null, educationDatesDegreeOne: null } });
													}

												}}

												hasError={touched.endYearDegreeOne && errors.endYearDegreeOne}
												errorMessage={errors.endYearDegreeOne}

												onBlur={(e) => handleBlur(e)}
												// onFocus event return TRUE, set touched to true, this can show/hide error message
												onFocus={(e) => {
													touched.endYearDegreeOne = e;
												}}

												// update formik value
												value={(year) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													values.endYearDegreeOne = year.value;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, endYearDegreeOne: year.value } });
												}}

											/>

										</div>



										<hr className="hr--dot-boston-pink" />
										<h3 className="color--boston-pink padding-bottom-20">Degree #2</h3>
										<div className="horizontal_div">
											<InputTxt
												id="degreeTwo" // need match value name
												name="degreeTwo" // name will not work for formik in this case for input box
												labelText={"Degree #2"}
												isRequired={degreeTwoReq ? true : false}
												// show error and error message is control by formik    
												errorMessage={errors.degreeTwo}
												maxLength={100}
												hasError={touched.degreeTwo && errors.degreeTwo}
												// onchange and onblur is return event, handle by formik
												onChange={handleChange}
												onBlur={handleBlur}
												// setup formik value
												getTextString={(degreeTwo) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, degreeTwo: degreeTwo.trim() } })
												}
												}
												value={values.degreeTwo}
											/>

											<InputTxt
												id="institutionTwo" // need match value name
												name="institutionTwo" // name will not work for formik in this case for input box
												labelText={"Institution"}
												isRequired={institutionTwoReq ? true : false}
												// show error and error message is control by formik    
												errorMessage={errors.institutionTwo}
												maxLength={50}
												hasError={touched.institutionTwo && errors.institutionTwo}
												// onchange and onblur is return event, handle by formik
												onChange={handleChange}
												onBlur={handleBlur}
												// setup formik value
												getTextString={(institutionTwo) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, institutionTwo: institutionTwo.trim() } })
												}
												}
												value={values.institutionTwo}
											/>
										</div>
										<div class="normal_txt padding-bottom-20">
											Dates Attended
										</div>

										{/* Replace MonthYear comp with Dropdowns startMonthDegreeTwo and startYearDegreeTwo for startDateDegreeTwo --JWM-3344 Missing/Invalid Dates  */}
										<div className="horizontal_div padding-bottom-20">
											<Dropdown
												id="startMonthDegreeTwo"
												name="startMonthDegreeTwo"
												label="Start Month"
												isRequired={startDateDegreeTwoReq ? true : false}
												isDisabled={false}
												helpMessage=""
												data={MONTHS}
												selectedItem={values.startMonthDegreeTwo || ''}

												disableDefault={false}
												getSelectedValue={(startMonthDegreeTwo) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, startMonthDegreeTwo: startMonthDegreeTwo.value } });
												}}
												onChange={(month) => {
													errors.startMonthDegreeTwo = "";
													let applicantEducation = observershipAppObject.applicantEducation;
													if (month) {
														values.startMonthDegreeTwo = month.value;
														setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, startMonthDegreeTwo: month.value } });

													} else {
														values.startMonthDegreeTwo = "";
														values.startDateDegreeTwo = "";
														values.educationDatesDegreeTwo = "";
														setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, startMonthDegreeTwo: null, startDateDegreeTwo: null, educationDatesDegreeTwo: null } });
													}

												}}

												hasError={touched.startMonthDegreeTwo && errors.startMonthDegreeTwo}
												errorMessage={errors.startMonthDegreeTwo}

												onBlur={(e) => handleBlur(e)}
												// onFocus event return TRUE, set touched to true, this can show/hide error message
												onFocus={(e) => {
													touched.startMonthDegreeTwo = e;
												}}

												// update formik value
												value={(month) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													values.startMonthDegreeTwo = month.value;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, startMonthDegreeTwo: month.value } });
												}}

											/>

											<Dropdown
												id="startYearDegreeTwo"
												name="startYearDegreeTwo"
												label="Start Year"
												isRequired={startDateDegreeTwoReq ? true : false}
												isDisabled={false}
												helpMessage=""
												data={yearsforDegree}
												selectedItem={values.startYearDegreeTwo || ''}
												disableDefault={false}
												getSelectedValue={(startYearDegreeTwo) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, startYearDegreeTwo: startYearDegreeTwo.value } });
												}}
												onChange={(year) => {
													errors.startYearDegreeTwo = "";
													let applicantEducation = observershipAppObject.applicantEducation;
													if (year) {
														values.startYearDegreeTwo = year.value;
														setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, startYearDegreeTwo: year.value } });

													} else {
														values.startYearDegreeTwo = "";
														values.startDateDegreeTwo = "";
														values.educationDatesDegreeTwo = "";
														setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, startYearDegreeTwo: null, startDateDegreeTwo: null, educationDatesDegreeTwo: null } });
													}

												}}

												hasError={touched.startYearDegreeTwo && errors.startYearDegreeTwo}
												errorMessage={errors.startYearDegreeTwo}

												onBlur={(e) => handleBlur(e)}
												// onFocus event return TRUE, set touched to true, this can show/hide error message
												onFocus={(e) => {
													touched.startYearDegreeTwo = e;
												}}

												// update formik value
												value={(year) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													values.startYearDegreeTwo = year.value;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, startYearDegreeTwo: year.value } });
												}}

											/>


										</div>

										{/* Dropdowns endMonthDegreeTwo and endYearDegreeTwo for endDateDegreeTwo --JWM-3344 Missing/Invalid Dates */}
										<div className="horizontal_div padding-bottom-20">

											<Dropdown
												id="endMonthDegreeTwo"
												name="endMonthDegreeTwo"
												label="End Month"
												isRequired={endDateDegreeTwoReq ? true : false}
												isDisabled={false}
												helpMessage=""
												data={MONTHS}
												selectedItem={values.endMonthDegreeTwo || ''}

												disableDefault={false}
												getSelectedValue={(endMonthDegreeTwo) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, endMonthDegreeTwo: endMonthDegreeTwo.value } });
												}}
												onChange={(month) => {
													errors.endMonthDegreeTwo = "";
													let applicantEducation = observershipAppObject.applicantEducation;
													if (month) {
														values.endMonthDegreeTwo = month.value;
														setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, endMonthDegreeTwo: month.value } });

													} else {
														values.endMonthDegreeTwo = "";
														values.endDateDegreeTwo = "";
														values.educationDatesDegreeTwo = "";

														setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, endMonthDegreeTwo: null, endDateDegreeTwo: null, educationDatesDegreeTwo: null } });
													}

												}}

												hasError={touched.endMonthDegreeTwo && errors.endMonthDegreeTwo}
												errorMessage={errors.endMonthDegreeTwo}

												onBlur={(e) => handleBlur(e)}
												// onFocus event return TRUE, set touched to true, this can show/hide error message
												onFocus={(e) => {
													touched.endMonthDegreeTwo = e;
												}}

												// update formik value
												value={(month) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													values.endMonthDegreeTwo = month.value;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, endMonthDegreeTwo: month.value } });
												}}

											/>

											<Dropdown
												id="endYearDegreeTwo"
												name="endYearDegreeTwo"
												label="End Year"
												isRequired={endDateDegreeTwoReq ? true : false}
												isDisabled={false}
												helpMessage=""
												data={yearsforDegree}
												selectedItem={values.endYearDegreeTwo || ''}
												disableDefault={false}
												getSelectedValue={(endYearDegreeTwo) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, endYearDegreeTwo: endYearDegreeTwo.value } });
												}}
												onChange={(year) => {
													errors.endYearDegreeTwo = "";
													let applicantEducation = observershipAppObject.applicantEducation;
													if (year) {
														values.endYearDegreeTwo = year.value;
														setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, endYearDegreeTwo: year.value } });

													} else {
														values.endYearDegreeTwo = "";
														values.endDateDegreeTwo = "";
														values.educationDatesDegreeTwo = "";
														setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, endYearDegreeTwo: null, endDateDegreeTwo: null, educationDatesDegreeTwo: null } });
													}

												}}

												hasError={touched.endYearDegreeTwo && errors.endYearDegreeTwo}
												errorMessage={errors.endYearDegreeTwo}

												onBlur={(e) => handleBlur(e)}
												// onFocus event return TRUE, set touched to true, this can show/hide error message
												onFocus={(e) => {
													touched.endYearDegreeTwo = e;
												}}

												// update formik value
												value={(year) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													values.endYearDegreeTwo = year.value;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, endYearDegreeTwo: year.value } });
												}}

											/>

										</div>




										<hr className="hr--dot-boston-pink" />
										<h3 className="color--boston-pink padding-bottom-20">Degree #3</h3>
										<div className="horizontal_div">
											<InputTxt
												id="degreeThree" // need match value name
												name="degreeThree" // name will not work for formik in this case for input box
												labelText={"Degree #3"}
												isRequired={degreeThreeReq ? true : false}
												// show error and error message is control by formik    
												errorMessage={errors.degreeThree}
												maxLength={100}
												hasError={touched.degreeThree && errors.degreeThree}
												// onchange and onblur is return event, handle by formik
												onChange={handleChange}
												onBlur={handleBlur}
												// setup formik value
												getTextString={(degreeThree) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, degreeThree: degreeThree.trim() } })
												}
												}
												value={values.degreeThree}
											/>

											<InputTxt
												id="institutionThree" // need match value name
												name="institutionThree" // name will not work for formik in this case for input box
												labelText={"Institution"}
												isRequired={institutionThreeReq ? true : false}
												// show error and error message is control by formik    
												errorMessage={errors.institutionThree}
												maxLength={50}
												hasError={touched.institutionThree && errors.institutionThree}
												// onchange and onblur is return event, handle by formik
												onChange={handleChange}
												onBlur={handleBlur}
												// setup formik value
												getTextString={(institutionThree) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, institutionThree: institutionThree.trim() } })
												}
												}
												value={values.institutionThree}
											/>
										</div>
										<div class="normal_txt padding-bottom-20">
											Dates Attended
										</div>

										{/* Replace MonthYear comp with Dropdowns startMonthDegreeThree and startYearDegreeThree for startDateDegreeThree --JWM-3344 Missing/Invalid Dates  */}
										<div className="horizontal_div padding-bottom-20">
											<Dropdown
												id="startMonthDegreeThree"
												name="startMonthDegreeThree"
												label="Start Month"
												isRequired={startDateDegreeThreeReq ? true : false}
												isDisabled={false}
												helpMessage=""
												data={MONTHS}
												selectedItem={values.startMonthDegreeThree || ''}

												disableDefault={false}
												getSelectedValue={(startMonthDegreeThree) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, startMonthDegreeThree: startMonthDegreeThree.value } });
												}}
												onChange={(month) => {
													errors.startMonthDegreeThree = "";
													let applicantEducation = observershipAppObject.applicantEducation;
													if (month) {
														values.startMonthDegreeThree = month.value;
														setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, startMonthDegreeThree: month.value } });

													} else {
														values.startMonthDegreeThree = "";
														values.startDateDegreeThree = "";
														values.educationDatesDegreeThree = "";
														setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, startMonthDegreeThree: null, startDateDegreeThree: null, educationDatesDegreeThree: null } });
													}

												}}

												hasError={touched.startMonthDegreeThree && errors.startMonthDegreeThree}
												errorMessage={errors.startMonthDegreeThree}

												onBlur={(e) => handleBlur(e)}
												// onFocus event return TRUE, set touched to true, this can show/hide error message
												onFocus={(e) => {
													touched.startMonthDegreeThree = e;
												}}

												// update formik value
												value={(month) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													values.startMonthDegreeThree = month.value;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, startMonthDegreeThree: month.value } });
												}}

											/>

											<Dropdown
												id="startYearDegreeThree"
												name="startYearDegreeThree"
												label="Start Year"
												isRequired={startDateDegreeThreeReq ? true : false}
												isDisabled={false}
												helpMessage=""
												data={yearsforDegree}
												selectedItem={values.startYearDegreeThree || ''}
												disableDefault={false}
												getSelectedValue={(startYearDegreeThree) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, startYearDegreeThree: startYearDegreeThree.value } });
												}}
												onChange={(year) => {
													errors.startYearDegreeThree = "";
													let applicantEducation = observershipAppObject.applicantEducation;
													if (year) {
														values.startYearDegreeThree = year.value;
														setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, startYearDegreeThree: year.value } });

													} else {
														values.startYearDegreeThree = "";
														values.startDateDegreeThree = "";
														values.educationDatesDegreeThree = "";
														setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, startYearDegreeThree: null, startDateDegreeThree: null, educationDatesDegreeThree: null } });
													}

												}}

												hasError={touched.startYearDegreeThree && errors.startYearDegreeThree}
												errorMessage={errors.startYearDegreeThree}

												onBlur={(e) => handleBlur(e)}
												// onFocus event return TRUE, set touched to true, this can show/hide error message
												onFocus={(e) => {
													touched.startYearDegreeThree = e;
												}}

												// update formik value
												value={(year) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													values.startYearDegreeThree = year.value;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, startYearDegreeThree: year.value } });
												}}

											/>


										</div>

										{/* Dropdowns endMonthDegreeThree and endYearDegreeThree for endDateDegreeThree --JWM-3344 Missing/Invalid Dates */}
										<div className="horizontal_div padding-bottom-20">

											<Dropdown
												id="endMonthDegreeThree"
												name="endMonthDegreeThree"
												label="End Month"
												isRequired={endDateDegreeThreeReq ? true : false}
												isDisabled={false}
												helpMessage=""
												data={MONTHS}
												selectedItem={values.endMonthDegreeThree || ''}

												disableDefault={false}
												getSelectedValue={(endMonthDegreeThree) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, endMonthDegreeThree: endMonthDegreeThree.value } });
												}}
												onChange={(month) => {
													errors.endMonthDegreeThree = "";
													let applicantEducation = observershipAppObject.applicantEducation;
													if (month) {
														values.endMonthDegreeThree = month.value;
														setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, endMonthDegreeThree: month.value } });

													} else {
														values.endMonthDegreeThree = "";
														values.endDateDegreeThree = "";
														values.educationDatesDegreeThree = "";

														setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, endMonthDegreeThree: null, endDateDegreeThree: null, educationDatesDegreeThree: null } });
													}

												}}

												hasError={touched.endMonthDegreeThree && errors.endMonthDegreeThree}
												errorMessage={errors.endMonthDegreeThree}

												onBlur={(e) => handleBlur(e)}
												// onFocus event return TRUE, set touched to true, this can show/hide error message
												onFocus={(e) => {
													touched.endMonthDegreeThree = e;
												}}

												// update formik value
												value={(month) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													values.endMonthDegreeThree = month.value;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, endMonthDegreeThree: month.value } });
												}}

											/>

											<Dropdown
												id="endYearDegreeThree"
												name="endYearDegreeThree"
												label="End Year"
												isRequired={endDateDegreeThreeReq ? true : false}
												isDisabled={false}
												helpMessage=""
												data={yearsforDegree}
												selectedItem={values.endYearDegreeThree || ''}
												disableDefault={false}
												getSelectedValue={(endYearDegreeThree) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, endYearDegreeThree: endYearDegreeThree.value } });
												}}
												onChange={(year) => {
													errors.endYearDegreeThree = "";
													let applicantEducation = observershipAppObject.applicantEducation;
													if (year) {
														values.endYearDegreeThree = year.value;
														setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, endYearDegreeThree: year.value } });

													} else {
														values.endYearDegreeThree = "";
														values.endDateDegreeThree = "";
														values.educationDatesDegreeThree = "";
														setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, endYearDegreeThree: null, endDateDegreeThree: null, educationDatesDegreeThree: null } });
													}

												}}

												hasError={touched.endYearDegreeThree && errors.endYearDegreeThree}
												errorMessage={errors.endYearDegreeThree}

												onBlur={(e) => handleBlur(e)}
												// onFocus event return TRUE, set touched to true, this can show/hide error message
												onFocus={(e) => {
													touched.endYearDegreeThree = e;
												}}

												// update formik value
												value={(year) => {
													let applicantEducation = observershipAppObject.applicantEducation;
													values.endYearDegreeThree = year.value;
													setObservershipAppObject({ ...observershipAppObject, applicantEducation: { ...applicantEducation, endYearDegreeThree: year.value } });
												}}

											/>

										</div>




										<br />
									</div>

									{/* -----CURRENT POSITION SECTION------ */}
									<CollapseBar
										id={"cb4"}
										title={"Current Position"}
										showNewLink={false}
										showMoveTop={false}
										showCollapseBT={false}
										initStateExpand={true}
									/>
									<div id="theDiv5Hide5" className="div_3_col">
										<div class="normal_txt">Program participants are required to have an existing home institution, and are generally one of the following:</div>
										<div class="normal_txt padding-bottom-20 div_1_col ">
											<div className="first-level">A practicing provider or clinician with a specific pediatric subspecialty background or demonstrated interest. (Examples include but are not limited to: cardiac surgeons, pediatric neurologists, pediatric cardiologists, pediatric endocrinologists, neonatologists, pediatric ophthalmologists, general psychiatrists with a focus on children, dieticians, and others).</div>
											<div class="relative_left_20"> - OR -</div>
											<div className="first-level">A current trainee enrolled in a residency or fellowship for a specific pediatric subspecialty. (Examples: pediatric resident, pediatric neurology fellow, surgical resident with an interest in pediatrics, neonatology fellow, and others).</div>
										</div>


										<div className="horizontal_div">
											<InputTxt
												id="currentTitle" // need match value name
												name="currentTitle" // name will not work for formik in this case for input box
												labelText={"Professional title"}
												isRequired={true}
												// show error and error message is control by formik    
												errorMessage={errors.currentTitle}
												maxLength={49}
												hasError={touched.currentTitle && errors.currentTitle}
												// onchange and onblur is return event, handle by formik
												onChange={handleChange}
												onBlur={handleBlur}
												// setup formik value
												getTextString={(currentTitle) => {
													setObservershipAppObject({ ...observershipAppObject, currentTitle: currentTitle.trim() });
													values.currentTitle = currentTitle;
												}}
											/>

											<InputTxt
												id="department" // need match value name
												name="department" // name will not work for formik in this case for input box
												labelText={"Department"}
												isRequired={true}
												// show error and error message is control by formik    
												errorMessage={errors.department}
												maxLength={49}
												hasError={touched.department && errors.department}
												// onchange and onblur is return event, handle by formik
												onChange={handleChange}
												onBlur={handleBlur}
												// setup formik value
												getTextString={(department) => {
													setObservershipAppObject({ ...observershipAppObject, department: department.trim() });
													values.department = department;
												}}
											/>
										</div>
										<InputTxt
											id="currentInstitution" // need match value name
											name="currentInstitution" // name will not work for formik in this case for input box
											labelText={"Hospital/Institution"}
											isRequired={true}
											// show error and error message is control by formik    
											errorMessage={errors.currentInstitution}
											maxLength={49}
											hasError={touched.currentInstitution && errors.currentInstitution}
											// onchange and onblur is return event, handle by formik
											onChange={handleChange}
											onBlur={handleBlur}
											// setup formik value
											getTextString={(currentInstitution) => {
												setObservershipAppObject({ ...observershipAppObject, currentInstitution: currentInstitution.trim() });
												values.currentInstitution = currentInstitution;
											}}
										/>
										<Dropdown
											id="positionCountry"
											name="positionCountry"
											label="Country/Region"
											isRequired={true}
											isDisabled={false}
											helpMessage=""
											data={COUNTRIES_LIST}
											selectedItem={values.positionCountry}
											value={values.positionCountry}
											disableDefault={false}
											getSelectedValue={(positionCountry) => { setObservershipAppObject({ ...observershipAppObject, positionCountry: positionCountry.value }); }}
											hasError={touched.positionCountry && errors.positionCountry}
											errorMessage={errors.positionCountry}
											onChange={(positionCountry) => {
												errors.positionCountry = "";
												setOtherPositionCountrySelected(false);
												values.otherPositionCountry = null;
												if (positionCountry) {
													values.positionCountry = positionCountry.value;
													if (positionCountry.value === "Other") {
														setOtherPositionCountrySelected(true);
														setObservershipAppObject({ ...observershipAppObject, positionCountry: "" });
													} else {
														setObservershipAppObject({ ...observershipAppObject, positionCountry: positionCountry.value });
													}
												} else {
													values.positionCountry = null;
													setObservershipAppObject({ ...observershipAppObject, positionCountry: null });
												}
											}}
											onFocus={(e) => {
												touched.positionCountry = e;
											}}
											onBlur={(e) => handleBlur(e)}
										/>

										<div className={(otherPositionCountrySelected ? 'show_div' : 'hide_div')}>
											<InputTxt
												id="otherPositionCountry"
												name="otherPositionCountry"
												labelText="Other country/region"
												helpMessage=""
												isRequired={otherPositionCountrySelected ? true : false}
												maxLength={100}
												errorMessage={errors.otherPositionCountry}
												hasError={touched.otherPositionCountry && errors.otherPositionCountry}
												onChange={handleChange}
												onBlur={handleBlur}
												value={values.otherPositionCountry}
												getTextString={(otherPositionCountry) => setObservershipAppObject({ ...observershipAppObject, positionCountry: otherPositionCountry.trim() })}
											/>
										</div>

										{/* Dropdowns for current position, replace MonthYear comp --JWM-3344 Missing/Invalid Dates */}
										<div className="horizontal_div">

											<Dropdown
												id="positionStartMonth"
												name="positionStartMonth"
												label="Start Month"
												isRequired={true}
												isDisabled={false}
												helpMessage=""
												data={MONTHS}
												selectedItem={values.positionStartMonth || ''}

												disableDefault={false}
												getSelectedValue={(positionStartMonth) => { setObservershipAppObject({ ...observershipAppObject, positionStartMonth: positionStartMonth.value }); }}
												onChange={(month) => {
													errors.positionStartMonth = "";
													if (month) {
														values.positionStartMonth = month.value;

														setObservershipAppObject({ ...observershipAppObject, positionStartMonth: month.value });

													} else {
														values.positionStartMonth = "";
														values.startDate = "";
														setObservershipAppObject({ ...observershipAppObject, positionStartMonth: null, startDate: null });
													}

												}}

												hasError={touched.positionStartMonth && errors.positionStartMonth}
												errorMessage={errors.positionStartMonth}

												onBlur={(e) => handleBlur(e)}
												// onFocus event return TRUE, set touched to true, this can show/hide error message
												onFocus={(e) => {
													touched.positionStartMonth = e;
												}}

												// update formik value
												value={(month) => {

													values.positionStartMonth = month.value;
													setObservershipAppObject({ ...observershipAppObject, positionStartMonth: month.value });
												}}

											/>

											<Dropdown
												id="positionStartYear"
												name="positionStartYear"
												label="Start Year"
												isRequired={true}
												isDisabled={false}
												helpMessage=""
												data={yearsforPosition}
												selectedItem={values.positionStartYear}
												disableDefault={false}
												getSelectedValue={(positionStartYear) => { setObservershipAppObject({ ...observershipAppObject, positionStartYear: positionStartYear.value }); }}
												onChange={(year) => {
													errors.positionStartYear = "";
													if (year) {
														values.positionStartYear = year.value;

														setObservershipAppObject({ ...observershipAppObject, positionStartYear: year.value });

													} else {
														values.positionStartYear = "";
														values.startDate = "";
														setObservershipAppObject({ ...observershipAppObject, positionStartYear: null, startDate: null });
													}
													// validateForm();									      

												}}

												hasError={touched.positionStartYear && errors.positionStartYear}
												errorMessage={errors.positionStartYear}
												onBlur={(e) => handleBlur(e)}
												// onFocus event return TRUE, set touched to true, this can show/hide error message
												onFocus={(e) => {
													touched.positionStartYear = e;
												}}

												// update formik value
												value={(year) => {

													values.positionStartYear = year.value;
													setObservershipAppObject({ ...observershipAppObject, positionStartYear: year.value });
												}}
											/>

										</div>



										<br />
									</div>

									{/* -----PROGRAM PREFERENCE SECTION -------- */}

									<CollapseBar
										id={"cb5"}
										title={"Program Preference"}
										showNewLink={false}
										showMoveTop={false}
										showCollapseBT={false}
										initStateExpand={true}
									/>

									<div id="theDiv6Hide5" className="div_3_col">
										<Dropdown
											data={dpvalue}
											label={"Department/Subspecialty"}
											isRequired={true}
											helpMessage=""
											defaultLabel={""}
											isDisabled={false}
											name="preferredDepartment"
											id="preferredDepartment"
											selectedItem={values.preferredDepartment}
											disableDefault={false}
											getSelectedValue={(preferredDepartment) => { setObservershipAppObject({ ...observershipAppObject, preferredDepartment: preferredDepartment.label }); }}
											// show error and error message is control by formik
											errorMessage={errors.preferredDepartment}
											hasError={touched.preferredDepartment && errors.preferredDepartment}
											// return event to formik
											onChange={(preferredDepartment) => {
												errors.preferredDepartment = "";
												values.preferredDepartmentOther = "";
												if (preferredDepartment) {
													setObservershipAppObject({ ...observershipAppObject, preferredDepartment: preferredDepartment.label });
													if (preferredDepartment.label === "Other") {
														setOtherDept(true);
													} else {
														setOtherDept(false);
													}
												} else {
													setObservershipAppObject({ ...observershipAppObject, preferredDepartment: "" });
													setOtherDept(false);
												}
											}}
											onBlur={(e) => handleBlur(e)}
											// onFocus event return TRUE, set touched to true, this can show/hide error message
											onFocus={(e) => {
												touched.preferredDepartment = e;
											}}
											// update formik value
											value={(preferredDepartment) => {
												let tmp = "";
												if (preferredDepartment) {
													tmp = preferredDepartment.label;
												}
												values.preferredDepartment = tmp;
												setObservershipAppObject({ ...observershipAppObject, preferredDepartment: tmp });
											}}
										/>

										<div id="otherDept" className={(otherDept ? 'show_div' : 'hide_div')}>
											<InputTxt
												id="preferredDepartmentOther" // need match value name
												name="preferredDepartmentOther" // name will not work for formik in this case for input box
												labelText={"Other Department/Subspecialty"}
												isRequired={otherDept}
												maxLength={100}
												// show error and error message is control by formik    
												errorMessage={errors.preferredDepartmentOther}
												hasError={touched.preferredDepartmentOther && errors.preferredDepartmentOther}
												// onchange and onblur is return event, handle by formik
												onChange={handleChange}
												onBlur={handleBlur}
												// setup formik value
												value={values.preferredDepartmentOther}
												getTextString={(preferredDepartment) => {
													if (otherDept) {
														if (preferredDepartment.trim() === "") {
															setObservershipAppObject({ ...observershipAppObject, preferredDepartment: "Other" });
														} else {
															setObservershipAppObject({ ...observershipAppObject, preferredDepartment: preferredDepartment.trim() });
														}
													}
												}}
											/>
										</div>
										<div className="horizontal_div">
											<div>
												<Dropdown
													data={durationValue}
													label={"Minimum desired duration"}
													isRequired={true}
													helpMessage=""
													defaultLabel={""}
													isDisabled={false}
													name="minDesiredDuration"
													id="minDesiredDuration"
													selectedItem={values.minDesiredDuration}
													disableDefault={false}
													getSelectedValue={(minDesiredDuration) => { setObservershipAppObject({ ...observershipAppObject, minDesiredDuration: minDesiredDuration.value }); }}
													// show error and error message is control by formik
													errorMessage={errors.minDesiredDuration}
													hasError={touched.minDesiredDuration && errors.minDesiredDuration}
													// return event to formik
													onChange={(minDesiredDuration) => {
														errors.minDesiredDuration = "";
														if (minDesiredDuration) {
															values.minDesiredDuration = minDesiredDuration.value;
															setObservershipAppObject({ ...observershipAppObject, minDesiredDuration: minDesiredDuration.value });

														} else {
															values.minDesiredDuration = null;
															setObservershipAppObject({ ...observershipAppObject, minDesiredDuration: null });
														}
													}}
													onBlur={(e) => handleBlur(e)}
													// onFocus event return TRUE, set touched to true, this can show/hide error message
													onFocus={(e) => {
														touched.minDesiredDuration = e;
													}}
													// update formik value
													value={(minDesiredDuration) => {
														values.minDesiredDuration = minDesiredDuration.value;

													}}
												/>
											</div>
											<div>
												<Dropdown
													data={durationValue}
													label={"Maximum desired duration"}
													isRequired={true}
													helpMessage="Please note that many divisions limit observations to 4 weeks"
													defaultLabel={""}
													isDisabled={false}
													name="maxDesiredDuration"
													id="maxDesiredDuration"
													selectedItem={values.maxDesiredDuration}
													disableDefault={false}
													getSelectedValue={(maxDesiredDuration) => { setObservershipAppObject({ ...observershipAppObject, maxDesiredDuration: maxDesiredDuration.value }); }}
													// show error and error message is control by formik
													errorMessage={errors.maxDesiredDuration}
													hasError={touched.maxDesiredDuration && errors.maxDesiredDuration}
													// return event to formik
													onChange={(maxDesiredDuration) => {
														errors.maxDesiredDuration = "";
														if (maxDesiredDuration) {
															values.maxDesiredDuration = maxDesiredDuration.value;
															setObservershipAppObject({ ...observershipAppObject, maxDesiredDuration: maxDesiredDuration.value });

														} else {
															values.maxDesiredDuration = null;
															setObservershipAppObject({ ...observershipAppObject, maxDesiredDuration: null });
														}

													}}
													onBlur={(e) => handleBlur(e)}
													// onFocus event return TRUE, set touched to true, this can show/hide error message
													onFocus={(e) => {
														touched.maxDesiredDuration = e;
													}}
													// update formik value
													value={(maxDesiredDuration) => {
														values.maxDesiredDuration = maxDesiredDuration.value;
													}}
												/>
											</div>
										</div>

										<h3 className="color--boston-pink padding-top-30 padding-bottom-20">Preferred Month(s)</h3>
										<div class="normal_txt padding-bottom-20">
											Please list all months you would be available to visit. If your observership is approved, we will try to accommodate you during your preferred month(s), but cannot guarantee availability.
										</div>

										<div>
											{/* Dropdowns for preferredStart, replace MonthYear comp --JWM-3344 Missing/Invalid Dates */}
											<div className="horizontal_div">

												<Dropdown
													id="preferredStartMonth"
													name="preferredStartMonth"
													label="Start Month"
													isRequired={true}
													isDisabled={false}
													helpMessage=""
													data={MONTHS}
													selectedItem={values.preferredStartMonth || ''}

													disableDefault={false}
													getSelectedValue={(preferredStartMonth) => { setObservershipAppObject({ ...observershipAppObject, preferredStartMonth: preferredStartMonth.value }); }}
													onChange={(month) => {
														errors.preferredStartMonth = "";
														if (month) {
															values.preferredStartMonth = month.value;

															setObservershipAppObject({ ...observershipAppObject, preferredStartMonth: month.value });

														} else {
															values.preferredStartMonth = "";
															values.preferredStart = "";
															values.preferredMonths = "";
															setObservershipAppObject({ ...observershipAppObject, preferredStartMonth: null, preferredStart: null, preferredMonths: null });
														}

													}}

													hasError={touched.preferredStartMonth && errors.preferredStartMonth}
													errorMessage={errors.preferredStartMonth}

													onBlur={(e) => handleBlur(e)}
													// onFocus event return TRUE, set touched to true, this can show/hide error message
													onFocus={(e) => {
														touched.preferredStartMonth = e;
													}}

													// update formik value
													value={(month) => {

														values.preferredStartMonth = month.value;
														setObservershipAppObject({ ...observershipAppObject, preferredStartMonth: month.value });
													}}

												/>

												<Dropdown
													id="preferredStartYear"
													name="preferredStartYear"
													label="Start Year"
													isRequired={true}
													isDisabled={false}
													helpMessage=""
													data={yearsforPreAvi}
													selectedItem={values.preferredStartYear}
													disableDefault={false}
													getSelectedValue={(preferredStartYear) => { setObservershipAppObject({ ...observershipAppObject, preferredStartYear: preferredStartYear.value }); }}
													onChange={(year) => {
														errors.preferredStartYear = "";
														if (year) {
															values.preferredStartYear = year.value;

															setObservershipAppObject({ ...observershipAppObject, preferredStartYear: year.value });

														} else {
															values.preferredStartYear = "";
															values.preferredStart = "";
															values.preferredMonths = "";
															setObservershipAppObject({ ...observershipAppObject, preferredStartYear: null, preferredStart: null, preferredMonths: null });
														}


													}}

													hasError={touched.preferredStartYear && errors.preferredStartYear}
													errorMessage={errors.preferredStartYear}
													onBlur={(e) => handleBlur(e)}
													// onFocus event return TRUE, set touched to true, this can show/hide error message
													onFocus={(e) => {
														touched.preferredStartYear = e;
													}}

													// update formik value
													value={(year) => {

														values.preferredStartYear = year.value;
														setObservershipAppObject({ ...observershipAppObject, preferredStartYear: year.value });
													}}
												/>

											</div>

											{/* Dropdowns for preferredEnd, replace MonthYear comp --JWM-3344 Missing/Invalid Dates */}
											<div className="horizontal_div">

												<Dropdown
													id="preferredEndMonth"
													name="preferredEndMonth"
													label="End Month"
													isRequired={true}
													isDisabled={false}
													helpMessage=""
													data={MONTHS}
													selectedItem={values.preferredEndMonth || ''}

													disableDefault={false}
													getSelectedValue={(preferredEndMonth) => { setObservershipAppObject({ ...observershipAppObject, preferredEndMonth: preferredEndMonth.value }); }}
													onChange={(month) => {
														errors.preferredEndMonth = "";
														if (month) {
															values.preferredEndMonth = month.value;

															setObservershipAppObject({ ...observershipAppObject, preferredEndMonth: month.value });

														} else {
															values.preferredEndMonth = "";
															values.preferredEnd = "";
															values.preferredMonths = "";
															setObservershipAppObject({ ...observershipAppObject, preferredEndMonth: null, preferredEnd: null, preferredMonths: null });
														}

													}}

													hasError={touched.preferredEndMonth && errors.preferredEndMonth}
													errorMessage={errors.preferredEndMonth}

													onBlur={(e) => handleBlur(e)}
													// onFocus event return TRUE, set touched to true, this can show/hide error message
													onFocus={(e) => {
														touched.preferredEndMonth = e;
													}}

													// update formik value
													value={(month) => {

														values.preferredEndMonth = month.value;
														setObservershipAppObject({ ...observershipAppObject, preferredEndMonth: month.value });
													}}

												/>

												<Dropdown
													id="preferredEndYear"
													name="preferredEndYear"
													label="End Year"
													isRequired={true}
													isDisabled={false}
													helpMessage=""
													data={yearsforPreAvi}
													selectedItem={values.preferredEndYear}
													disableDefault={false}
													getSelectedValue={(preferredEndYear) => { setObservershipAppObject({ ...observershipAppObject, preferredEndYear: preferredEndYear.value }); }}
													onChange={(year) => {
														errors.preferredEndYear = "";
														if (year) {
															values.preferredEndYear = year.value;

															setObservershipAppObject({ ...observershipAppObject, preferredEndYear: year.value });

														} else {
															values.preferredEndYear = "";
															values.preferredEnd = "";
															values.preferredMonths = "";
															setObservershipAppObject({ ...observershipAppObject, preferredEndYear: null, preferredEnd: null, preferredMonths: null });
														}


													}}

													hasError={touched.preferredEndYear && errors.preferredEndYear}
													errorMessage={errors.preferredEndYear}
													onBlur={(e) => handleBlur(e)}
													// onFocus event return TRUE, set touched to true, this can show/hide error message
													onFocus={(e) => {
														touched.preferredEndYear = e;
													}}

													// update formik value
													value={(year) => {

														values.preferredEndYear = year.value;
														setObservershipAppObject({ ...observershipAppObject, preferredEndYear: year.value });
													}}
												/>

											</div>
										</div>

										<h3 className="color--boston-pink padding-top-30 padding-bottom-20">Available Month(s)</h3>

										<div>
											{/* Dropdowns for availableStart, replace MonthYear comp --JWM-3344 Missing/Invalid Dates */}
											<div className="horizontal_div">

												<Dropdown
													id="availableStartMonth"
													name="availableStartMonth"
													label="Start Month"
													isRequired={true}
													isDisabled={false}
													helpMessage=""
													data={MONTHS}
													selectedItem={values.availableStartMonth || ''}

													disableDefault={false}
													getSelectedValue={(availableStartMonth) => { setObservershipAppObject({ ...observershipAppObject, availableStartMonth: availableStartMonth.value }); }}
													onChange={(month) => {
														errors.availableStartMonth = "";
														if (month) {
															values.availableStartMonth = month.value;

															setObservershipAppObject({ ...observershipAppObject, availableStartMonth: month.value });

														} else {
															values.availableStartMonth = "";
															values.availableStart = "";
															values.availableMonths = "";
															setObservershipAppObject({ ...observershipAppObject, availableStartMonth: null, availableStart: null, availableMonths: null });
														}

													}}

													hasError={touched.availableStartMonth && errors.availableStartMonth}
													errorMessage={errors.availableStartMonth}

													onBlur={(e) => handleBlur(e)}
													// onFocus event return TRUE, set touched to true, this can show/hide error message
													onFocus={(e) => {
														touched.availableStartMonth = e;
													}}

													// update formik value
													value={(month) => {

														values.availableStartMonth = month.value;
														setObservershipAppObject({ ...observershipAppObject, availableStartMonth: month.value });
													}}

												/>

												<Dropdown
													id="availableStartYear"
													name="availableStartYear"
													label="Start Year"
													isRequired={true}
													isDisabled={false}
													helpMessage=""
													data={yearsforPreAvi}
													selectedItem={values.availableStartYear}
													disableDefault={false}
													getSelectedValue={(availableStartYear) => { setObservershipAppObject({ ...observershipAppObject, availableStartYear: availableStartYear.value }); }}
													onChange={(year) => {
														errors.availableStartYear = "";
														if (year) {
															values.availableStartYear = year.value;

															setObservershipAppObject({ ...observershipAppObject, availableStartYear: year.value });

														} else {
															values.availableStartYear = "";
															values.availableStart = "";
															values.availableMonths = "";
															setObservershipAppObject({ ...observershipAppObject, availableStartYear: null, availableStart: null, availableMonths: null });
														}


													}}

													hasError={touched.availableStartYear && errors.availableStartYear}
													errorMessage={errors.availableStartYear}
													onBlur={(e) => handleBlur(e)}
													// onFocus event return TRUE, set touched to true, this can show/hide error message
													onFocus={(e) => {
														touched.availableStartYear = e;
													}}

													// update formik value
													value={(year) => {

														values.availableStartYear = year.value;
														setObservershipAppObject({ ...observershipAppObject, availableStartYear: year.value });
													}}
												/>

											</div>

											{/* Dropdowns for availableEnd, replace MonthYear comp --JWM-3344 Missing/Invalid Dates */}
											<div className="horizontal_div">

												<Dropdown
													id="availableEndMonth"
													name="availableEndMonth"
													label="End Month"
													isRequired={true}
													isDisabled={false}
													helpMessage=""
													data={MONTHS}
													selectedItem={values.availableEndMonth || ''}

													disableDefault={false}
													getSelectedValue={(availableEndMonth) => { setObservershipAppObject({ ...observershipAppObject, availableEndMonth: availableEndMonth.value }); }}
													onChange={(month) => {
														errors.availableEndMonth = "";
														if (month) {
															values.availableEndMonth = month.value;

															setObservershipAppObject({ ...observershipAppObject, availableEndMonth: month.value });

														} else {
															values.availableEndMonth = "";
															values.availableEnd = "";
															values.availableMonths = "";
															setObservershipAppObject({ ...observershipAppObject, availableEndMonth: null, availableEnd: null, availableMonths: null });
														}

													}}

													hasError={touched.availableEndMonth && errors.availableEndMonth}
													errorMessage={errors.availableEndMonth}

													onBlur={(e) => handleBlur(e)}
													// onFocus event return TRUE, set touched to true, this can show/hide error message
													onFocus={(e) => {
														touched.availableEndMonth = e;
													}}

													// update formik value
													value={(month) => {

														values.availableEndMonth = month.value;
														setObservershipAppObject({ ...observershipAppObject, availableEndMonth: month.value });
													}}

												/>

												<Dropdown
													id="availableEndYear"
													name="availableEndYear"
													label="End Year"
													isRequired={true}
													isDisabled={false}
													helpMessage=""
													data={yearsforPreAvi}
													selectedItem={values.availableEndYear}
													disableDefault={false}
													getSelectedValue={(availableEndYear) => { setObservershipAppObject({ ...observershipAppObject, availableEndYear: availableEndYear.value }); }}
													onChange={(year) => {
														errors.availableEndYear = "";
														if (year) {
															values.availableEndYear = year.value;

															setObservershipAppObject({ ...observershipAppObject, availableEndYear: year.value });

														} else {
															values.availableEndYear = "";
															values.availableEnd = "";
															values.availableMonths = "";
															setObservershipAppObject({ ...observershipAppObject, availableEndYear: null, availableEnd: null, availableMonths: null });
														}


													}}

													hasError={touched.availableEndYear && errors.availableEndYear}
													errorMessage={errors.availableEndYear}
													onBlur={(e) => handleBlur(e)}
													// onFocus event return TRUE, set touched to true, this can show/hide error message
													onFocus={(e) => {
														touched.availableEndYear = e;
													}}

													// update formik value
													value={(year) => {

														values.availableEndYear = year.value;
														setObservershipAppObject({ ...observershipAppObject, availableEndYear: year.value });
													}}
												/>

											</div>
										</div>




										<br />
									</div>
									{/* ----------REQUIRED DOCUMENTS SECTION (JWM-1173)  --------- */}

									<CollapseBar
										id={"cb6"}
										title={"Required Documents"}
										showNewLink={false}
										showMoveTop={false}
										showCollapseBT={false}
										initStateExpand={true}
									/>
									<div id="theDiv7Hide5" className="div_3_col">
										<div class="normal_txt padding-bottom-20">
											Documents must be uploaded as PDF files.<a href="https://www.freepdfconvert.com/" target="_blank" rel="noopener noreferrer"> Convert or create PDF files</a>

											<h3 className="color--boston-pink padding-top-30 padding-bottom-20">Curriculum Vitae</h3>
											Please provide a current resume or CV. Ideally, this would be about 1-2 pages in length and include dates and locations of your education and employment.
										</div>
										<div>
											<FileUpload
												id="cvUploaded"
												label={"Upload curriculum vitae"}
												name="cvUploaded"
												isRequired={true}
												numberOfFiles={1}
												fileSize={"2MB"} // default 5MB each file
												fileType={["pdf"]}
												maxFileNameLength={60} //Database column that stores the file name is limited to 100	
												instructionMessage={fileUploadInstructionMessage}
												helpMessage={"File format: .pdf (limit 1 file under 2 MB)"}
												hasError={touched.cvUploaded && errors.cvUploaded}
												errorMessage={errors.cvUploaded}
												uploadApi={fileUploadApi + "cv"}
												onChange={(e) => {
													// e is an array of loaded file items
													let tmp = e && e.length > 0 && e[0] !== 'F' && e[0].filename.length < 60;
													setCurriculumVitaeUploaded(tmp ? true : false);

													touched.cvUploaded = true;
													if (!tmp) {
														if (e.length === 0) {
															setFieldError("cvUploaded", cvErrorMessage);	//need to display field error when fileupload on change	
														}
														else if (e[0].filename.length > 60) {
															setFieldError("cvUploaded", invalidFileLength);	//need to display field error when fileupload on change	
														}
														else {
															setFieldError("cvUploaded", invalidFileErrorMessage);	//need to display field error when fileupload on change	
														}

													} else {
														setFieldError("cvUploaded", null);
													}

												}}
												onBlur={(e) => { }}
											/>
											<hr className="hr--dot-boston-pink" />
										</div>
										<div class="normal_txt padding-bottom-20">
											<h3 className="color--boston-pink padding-top-30 padding-bottom-20">Statement of Purpose</h3>
											<p>Your statement should be 1-2 pages and describe the following: (1) your current position, clinical responsibilities, and professional background; (2) your experience and interest in the pediatric subspecialty you are applying to; (3) three specific clinical learning objectives you hope to achieve during an observership; and (4) how you aim to apply the knowledge and practices observed at Boston Children's Hospital to your clinical practice.</p>
																							<p>Please note that observerships are strictly observational, hand-on practice and research activities are not permitted. Learning objectives should be specific to the selected subspecialty and should clearly describe what you hope to observe, learn, or better understand during your visit. If applicable, please include explanation of any time gaps in your resume.</p>
										</div>
										<div>
											<FileUpload
												id="sopUploaded"
												label={"Upload statement of purpose"}
												name="sopUploaded"
												isRequired={true}
												numberOfFiles={1}
												fileSize={"2MB"} // default 5MB each file
												fileType={["pdf"]}
												maxFileNameLength={60} //Database column that stores the file name is limited to 100	
												instructionMessage={fileUploadInstructionMessage}
												helpMessage={"File format: .pdf (limit 1 file under 2 MB)"}
												hasError={touched.sopUploaded && errors.sopUploaded}
												errorMessage={errors.sopUploaded}
												uploadApi={fileUploadApi + "sop"}
												onChange={(e) => {
													// e is an array of loaded file items
													let tmp = e && e.length > 0 && e[0] !== 'F' && e[0].filename.length < 60;
													setStatementOfPurposeUploaded(tmp ? true : false);

													touched.sopUploaded = true;
													if (!tmp) {
														if (e.length === 0) {
															setFieldError("sopUploaded", sopErrorMessage);
														}
														else if (e[0].filename.length > 60) {
															setFieldError("sopUploaded", invalidFileLength);	//need to display field error when fileupload on change	
														}
														else {
															setFieldError("sopUploaded", invalidFileErrorMessage);	//need to display field error when fileupload on change							
														}
													} else {
														setFieldError("sopUploaded", null);
													}
												}}
												onBlur={(e) => { }}
											/>
											<hr className="hr--dot-boston-pink" />
										</div>
										<div class="normal_txt padding-bottom-20">
											<h3 className="color--boston-pink padding-top-30 padding-bottom-20">Letter of Support</h3>
											This letter should be written by your current supervisor at your place of employment where you are currently training or practicing and show that you are authorized to temporarily leave your duties for an Observership if accepted. It should be printed on official letterhead, written in English, signed, and dated within the last 3 months.
										</div>
										<div>
											<FileUpload
												id="losUploaded"
												label={"Upload letter of support"}
												name="losUploaded"
												isRequired={true}
												numberOfFiles={1}
												fileSize={"2MB"} // default 5MB each file
												fileType={["pdf"]}
												maxFileNameLength={60} //Database column that stores the file name is limited to 100	
												instructionMessage={fileUploadInstructionMessage}
												helpMessage={"File format: .pdf (limit 1 file under 2 MB)"}
												hasError={touched.losUploaded && errors.losUploaded}
												errorMessage={errors.losUploaded}
												uploadApi={fileUploadApi + "los"}
												onChange={(e) => {
													// e is an array of loaded file items
													let tmp = e && e.length > 0 && e[0] !== 'F' && e[0].filename.length < 60;
													setLetterOfSupportUploaded(tmp ? true : false);

													touched.losUploaded = true;
													if (!tmp) {
														if (e.length === 0) {
															setFieldError("losUploaded", losErrorMessage);
														}
														else if (e[0].filename.length > 60) {
															setFieldError("losUploaded", invalidFileLength);	//need to display field error when fileupload on change	
														}
														else {
															setFieldError("losUploaded", invalidFileErrorMessage);	//need to display field error when fileupload on change	
														}
													} else {
														setFieldError("losUploaded", null);
													}

												}}
												onBlur={(e) => { }}
											/>
											<hr className="hr--dot-boston-pink" />
										</div>
										<div class="normal_txt">
											<h3 className="color--boston-pink padding-top-30 padding-bottom-20">Recent Photograph</h3>
										</div>
										<div>
											<FileUpload
												id="rPhotographUploaded"
												label={"Upload recent photograph"}
												name="rPhotographUploaded"
												isRequired={true} //temp change, change back later ***********************************************************
												numberOfFiles={1}
												fileSize={"3MB"} // default 5MB each file
												fileType={["pdf", "image_basic"]}
												maxFileNameLength={60} //Database column that stores the file name is limited to 100	
												instructionMessage={fileUploadInstructionMessage}
												helpMessage={"Recommended file formats include .gif, .jpeg, .jpg, .pdf, or .png (limit 1 file under 3 MB)"}
												hasError={touched.rPhotographUploaded && errors.rPhotographUploaded}
												errorMessage={errors.rPhotographUploaded}
												uploadApi={fileUploadApi + "rp"}
												onChange={(e) => {
													// e is an array of loaded file items
													let tmp = e && e.length > 0 && e[0] !== 'F' && e[0].filename.length < 60;
													setRecentPhotographUploaded(tmp ? true : false);

													touched.rPhotographUploaded = true;
													if (!tmp) {
														if (e.length === 0) {
															setFieldError("rPhotographUploaded", rpErrorMessage);
														}
														else if (e[0].filename.length > 60) {
															setFieldError("rPhotographUploaded", invalidFileLength);	//need to display field error when fileupload on change	
														}
														else {
															setFieldError("rPhotographUploaded", invalidPhotoErrorMessage);	//need to display field error when fileupload on change	
														}
													} else {
														setFieldError("rPhotographUploaded", null);
													}

												}}
												onBlur={(e) => { }}
											/>
											<hr className="hr--dot-boston-pink" />
										</div>
										<div>
											<TextArea
												id="additionalComments"
												name="additionalComments"
												labelText={"Additional comments"}
												isRequired={false}
												helpMessage={"Please only add additional information here if you need to clarify any information provided in the other sections of your application."}
												rows={4}
												maxLength={400}
												getTextString={(additionalComments) => setObservershipAppObject({ ...observershipAppObject, additionalComments: additionalComments })}
												onChange={(additionalComments) => {
													if (additionalComments) {
														setObservershipAppObject({ ...observershipAppObject, additionalComments: additionalComments });
													}
												}}
												value={observershipAppObject.additionalComments}
												hasError={touched.additionalComments && errors.additionalComments}
												errorMessage={errors.additionalComments}
												onBlur={handleBlur}
											/>
										</div>

									</div>
									{ /*-----------------END REQUIRED DOCUMENTS SECTION------------------*/}
									{/* ----------TERMS AND AGREEMENT SECTION  --------- */}
									<CollapseBar
										id={"cb7"}
										title={"Terms and Agreement"}
										showNewLink={false}
										showMoveTop={false}
										showCollapseBT={false}
										initStateExpand={true}
									/>

									<div id="theDiv8Hide5" className="div_3_col">
										<div class="normal_txt padding-bottom-20">
											Please note that submission of your application and supporting documents does not guarantee admission into an observership program. Additionally, further documents may be requested by the sponsoring department.
										</div>
										<div class="normal_txt padding-bottom-20">
											Please review the <a href={ExpectationsPdf} target="_blank" rel="noopener noreferrer">Expectations for Observers</a> (PDF) handout prior to submitting your application.
										</div>
										<div class="normal_txt padding-bottom-20">
											I certify by submitting this application that I have read and understood the application. Furthermore, I acknowledge that the information I have provided is correct and complete to the best of my knowledge. I understand that providing false or incomplete information may be cause for disqualification or termination of the observership if appointed.
										</div>
										<div class="normal_txt padding-bottom-20">
											If you have any questions, please contact us at: <a href="mailto:observership.program@childrens.harvard.edu">observership.program@childrens.harvard.edu.</a>
										</div>

										<CheckBoxes
											id={"termsAndConditions"}
											label={"Terms & conditions agreement"}
											name="termsAndConditions"
											data={termsCheckbox}
											selectedItem={observershipAppObject.termsAndConditions}
											isRequired={true}
											layoutVertical={true}
											hasError={touched.termsAndConditions && errors.termsAndConditions}
											errorMessage={errors.termsAndConditions}
											value={(termsAndConditions) => {
											}}
											onChange={(termsAndConditions) => {
												setObservershipAppObject({ ...observershipAppObject, termsAndConditions: termsAndConditions });
											}}
											onBlur={(termsAndConditions) => {
												setObservershipAppObject({ ...observershipAppObject, termsAndConditions: termsAndConditions });
											}}
											onFocus={(termsAndConditions) => {
											}}
										/>

										<Dropdown
											data={hearAboutData}
											label={"How did you hear about the Observership Program?"}
											isRequired={true}
											helpMessage=""
											defaultLabel={""}
											isDisabled={false}
											name="hearAbout"
											id="hearAbout"
											selectedItem={values.hearAbout}
											disableDefault={false}
											getSelectedValue={(hearAbout) => { setObservershipAppObject({ ...observershipAppObject, hearAbout: hearAbout.value }); }}
											// show error and error message is control by formik
											errorMessage={errors.hearAbout}
											hasError={touched.hearAbout && errors.hearAbout}
											// return event to formik
											onChange={(hearAbout) => {
												errors.hearAbout = "";
												values.hearAboutText = "";
												if (hearAbout) {
													setObservershipAppObject({ ...observershipAppObject, hearAbout: hearAbout.value });
													//show input text if value is Other 
													if (hearAbout.value === "Other (please specify)") {
														setOtherInput(true);
														setBchStaff(false);
													} else if (hearAbout.value === "Boston Children's Hospital Staff") {
														setOtherInput(true);
														setBchStaff(true);
													} else {
														setOtherInput(false);
														setBchStaff(false);
													}
												} else {
													setObservershipAppObject({ ...observershipAppObject, hearAbout: "" });
													setOtherInput(false);
												}
											}}
											// onFocus event return TRUE, set touched to true, this can show/hide error message
											onFocus={(e) => {
												touched.hearAbout = e;
											}}
											onBlur={(e) => handleBlur(e)}
											value={(hearAbout) => {
												let tmp2 = "";
												if (hearAbout) {
													tmp2 = hearAbout.value;
												}
												values.hearAbout = tmp2;
												setObservershipAppObject({ ...observershipAppObject, hearAbout: tmp2 });
											}}
										/>

										<div id="otherHearAbout" className={(otherInput ? 'show_div' : 'hide_div')}>
											<InputTxt
												id="hearAboutText" // need match value name
												name="hearAboutText" // name will not work for formik in this case for input box
												labelText={bchStaff ? "Staff name or hospital contact" : "Please indicate how you heard about the Observership Program"}
												isRequired={otherInput}
												maxLength={150}
												errorMessage={errors.hearAboutText}
												hasError={touched.hearAboutText && errors.hearAboutText && otherInput}
												onChange={handleChange}
												onBlur={handleBlur}
												value={values.hearAboutText}
												// setup formik value
												getTextString={(hearAboutOther) => {
													//values.hearAboutText = hearAbout;
													if (otherInput) {
														if (hearAboutOther.trim() === "") {
															setObservershipAppObject({ ...observershipAppObject, hearAbout: "Other (please specify)" });
														} else {
															if (bchStaff) {
																setObservershipAppObject({ ...observershipAppObject, hearAbout: "BCH staff name: " + hearAboutOther.trim() });
															} else {
																setObservershipAppObject({ ...observershipAppObject, hearAbout: hearAboutOther.trim() });
															}
														}
													}
												}}
											/>
										</div>
										<div>
											<Button
												text={"SUBMIT APPLICATION"}
												styleName={"button button--primary"}
												id={"button_submit"}
												type="submit"
												onClick={(e) => { setFormSubmitted(true); validateForm(); window.scrollTo({ top: 0, left: 0, behavior: 'auto' }); }}
											/>
											<div className="normal_txt  normal_italic_txt">

											</div>
										</div>
									</div>
								</div>
							</div>
						</form>
					)}
				</Formik>

			</div>
		</>
	);
}

export default ObservershipApplicationForm;

